import SearchList, { SearchListWrapper } from '../components/SearchList'
import { TitleButton } from '../components/TitleButton'
import { PowerSellBoard } from '../components/PowerSellBoard'
import {
  SellPlanWorkspaceHeader,
  SellPlanWorkspaceTab,
} from '../components/SellPlanWorkspaceHeader'
import LabelInput from '../components/LabelInput'
import LabelAutoComplete from '../components/LabelAutoComplete'
import InputOnly from '../components/InputOnly'
import {
  TotalPurchaseValue,
  buyTOUList,
} from '../components/TotalPurchaseValue'
import LabelOnly from '../components/LabelOnly'
import Ratio from '../components/Ratio'
import LabelUnit from '../components/LabelUnit'
import ColumnRadioWtihSub from '../components/ColumnRadioWithSub'
import ColumnRadioCostRatio from '../components/ColumnRadioCostRatio'
import ColumnRadioButton from '../components/ColumnRadioButton'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useLazyQuery, useMutation, useQuery } from '@apollo/client'
import { findAllUnitDefaultGQL } from './DataUnit'
import { seasonMapping } from '../util/algorithm/fakeRatesData'
import {
  AnalysisConditionGrid,
  AnalysisConditionItem,
  AnalysisConditionLabel,
  AnalysisConditionValue,
  AnalysisGrid,
  AnalysisPanel,
  AnalysisPanelTitle,
  AnalysisWrapper,
  Body,
  BodyWrapper,
  ChargeFrame,
  ChargeWrapper,
  CollapsibleSectionTitle,
  ContentWrapper,
  PageWrapper,
  DetailColWrapper,
  DetailDescriptionText,
  DetailFrame,
  DetailWrapper,
  FeasibilityBarChart,
  FeasibilityBarChartHeader,
  FeasibilityBarFill,
  FeasibilityBarLabel,
  FeasibilityBarRow,
  FeasibilityBarTrack,
  FeasibilityBarValue,
  FeasibilityBarGuideRow,
  FeasibilityCurrentLegend,
  FeasibilityCurrentLegendSpacer,
  FeasibilityCurrentMarker,
  FeasibilityLimitMarker,
  FeasibilityLoadingRow,
  FeasibilitySpinner,
  FeasibilitySummaryCard,
  FeasibilitySummaryGrid,
  FeasibilitySummaryLabel,
  FeasibilitySummarySuffix,
  FeasibilitySummaryValue,
  GraphBody,
  GraphWrapper,
  Header,
  InUnitContent,
  InUnitItem,
  InUnitLabel,
  Input,
  Left,
  MonthChip,
  MonthChipText,
  MonthChipWrapper,
  OptionDetailBox,
  OptionDetailWrapper,
  OptionFrame,
  OptionListWrapper,
  OptionTextBox,
  PlanDefaultSummaryBox,
  PlanDefaultSummaryItem,
  PlanDefaultSummaryLabel,
  PlanDefaultSummaryValue,
  ProfitShareSummaryCard,
  ProfitShareSummaryGrid,
  ProfitShareSummaryLabel,
  ProfitShareSummarySubText,
  ProfitShareSummaryValue,
  ProfitShareRateControl,
  ProfitShareRateInput,
  ProfitShareRateInputWrapper,
  ProfitShareRateLabel,
  ProfitShareRateMeta,
  ProfitShareRateUnit,
  Rectangle,
  Right,
  SeasonBox,
  SeasonFrame,
  SeasonTextBox,
  SectionDivider,
  SectionFrame,
  SectionHeader,
  SectionMark,
  SectionTitle,
  SectionTitleChevron,
  SectionTitleToggleText,
  Table,
  TableCell,
  TableCell2,
  TableRow,
  Text,
  TextBox,
  TextBox2,
  TextWrapper,
} from '../style/SellPlans.styled'
import {
  CreateSellTOUGQL,
  DeleteSellTOUGQL,
  findAllLoadCustGQL,
  findAllSellTOUGQL,
  findLoadDataGQL,
  findOneSellTOUGQL,
  UpdateSellTOUGQL,
} from '../gql/SellPlans.gql'
import {
  findOneBuyTOUGQL,
  findOneKepcoTOUGQL,
  findPVDataGQL,
  getHolidaysGQL,
} from '../gql/PurchasePlans.gql'
import {
  IChargeUnit,
  ISeasonalNum,
  ISeasonalPVCharge,
  ISeasonalReduceCharge,
  ITimeDataItem,
  ITouRate,
} from '../util/algorithm/algoInterface'
import { calKepcoAverage } from '../util/algorithm/kepcoTOU'
import {
  calSeasonalSum,
  monthLoadTimeToSeasonLoadTime,
  monthSumToSeasonSum,
} from '../util/algorithm/monthToSeason'
import {
  ISeasonalNumMulNum,
  ISeasonalNumPlusISeasonalNum,
  SeasonalPVChargeToSeasonalCharge,
  calReduceCharge,
  calSeasonalExCharge,
  subtractPrevProfitToTradingCharge,
} from '../util/algorithm/calExCharge'
import { findOneLoadcusGQL } from '../gql/CustomerLoad.gql'
import TOUHeatMap from '../components/graph/TOUHeatMap'
import {
  calLoadTimeSum,
  calMonthSum,
  divTimeData,
  mulTimeData,
} from '../util/algorithm/classifyTimeData'
import { calMonthRepPattern } from '../util/algorithm/calRepPattern'
import {
  calKepcoMonthlyChargeAsUsage,
  calMonthlyChargeAsUsage,
} from '../util/algorithm/calCharge'
import PowerSourceStackedAreaChart from '../components/graph/PowerSourceStackedAreaChart'
import {
  calFlatTouUnitCharge,
  calMinChargeUnit,
  calTouUnitCharge,
} from '../util/algorithm/makeTOU'
import { INIT_KEPCO_TOU_PERIODS } from '../util/contants'
import {
  buildPeakDeductionLoadData,
  calPeakDeductionSellPlan,
  sumBuyCostGeneration,
} from '../util/algorithm/peakDeductionSellPlan'
import {
  SellPlanUnitPriceCurve,
  buildPeakDeductionSellPlanUnitPriceCurve,
  buildSellPlanUnitPriceCurve,
} from '../util/algorithm/sellPlanFeasibility'
import SellPlanFeasibilityChart from '../components/graph/SellPlanFeasibilityChart'
import SellPlanProfitShareSensitivityChart, {
  ProfitShareSensitivityPoint,
} from '../components/graph/SellPlanProfitShareSensitivityChart'

export interface ISellPlansData {
  _id?: string
  name: string
  cust: any
  touVer: string
  holidayYear: any
  environmentalUnit: number
  loadOpt: string
  buyTOUList: any[]
  essPowerRate: number
  afterKEPCOContractedPower: number
  planType: string
  rateOpt: string
  networkOpt: string
  internalNetworkUnitBaseUnit?: number
  internalNetworkUnitPowerUnit?: number
  distributionUnitBaseUnit?: number
  distributionUnitUsageUnit?: number
  lossCostMinUnit?: number
  lossCostMidUnit?: number
  lossCostMaxUnit?: number
  additionalSettlementUnit?: number
  transactionCommissionUnit?: number
  discountedPriceUnit?: number
  transmissionLossCostUnit?: number
  ectCostUnit?: number
  greenPremiumUnit?: number
  essProfitRate: number
  chargeUnitResult: any
  touPeriodResult: any
  sprMinMidRate?: number
  sprMinMaxRate?: number
  sumMinMidRate?: number
  sumMinMaxRate?: number
  fallMinMidRate?: number
  fallMinMaxRate?: number
  winMinMidRate?: number
  winMinMaxRate?: number
  powerMarketTransactionUnit?: number
}

export const initializeSellPlansData = (): ISellPlansData => {
  return {
    name: '',
    cust: '',
    touVer: '',
    holidayYear: '',
    environmentalUnit: 0,
    loadOpt: 'realTime',
    buyTOUList: [],
    essPowerRate: 0,
    afterKEPCOContractedPower: 0,
    planType: 'peakDeduction',
    rateOpt: 'single',
    networkOpt: 'ignore',
    essProfitRate: 10,
    chargeUnitResult: {
      spr: {
        min: 0,
        mid: 0,
        max: 0,
      },
      sum: {
        min: 0,
        mid: 0,
        max: 0,
      },
      fall: {
        min: 0,
        mid: 0,
        max: 0,
      },
      win: {
        min: 0,
        mid: 0,
        max: 0,
      },
    },
    touPeriodResult: INIT_KEPCO_TOU_PERIODS,
    powerMarketTransactionUnit: 0, // 판매요금제에는 필요없지만 임시로
    greenPremiumUnit: 11, // 판매요금제에는 필요없지만 단가 기본값 병합 시 사용
  }
}

const EMPTY_SEASONAL_NUM: ISeasonalNum = {
  spr: 0,
  sum: 0,
  fall: 0,
  win: 0,
}

const sumSeasonalNum = (value: ISeasonalNum) =>
  value.spr + value.sum + value.fall + value.win

const roundUnit = (value: number, fractionDigits: number) => {
  const multiplier = 10 ** fractionDigits
  return Math.round(value * multiplier) / multiplier
}

const roundChargeUnitResult = (
  chargeUnit: IChargeUnit,
  fractionDigits: number
): IChargeUnit => ({
  spr: {
    min: roundUnit(chargeUnit.spr.min, fractionDigits),
    mid: roundUnit(chargeUnit.spr.mid, fractionDigits),
    max: roundUnit(chargeUnit.spr.max, fractionDigits),
  },
  sum: {
    min: roundUnit(chargeUnit.sum.min, fractionDigits),
    mid: roundUnit(chargeUnit.sum.mid, fractionDigits),
    max: roundUnit(chargeUnit.sum.max, fractionDigits),
  },
  fall: {
    min: roundUnit(chargeUnit.fall.min, fractionDigits),
    mid: roundUnit(chargeUnit.fall.mid, fractionDigits),
    max: roundUnit(chargeUnit.fall.max, fractionDigits),
  },
  win: {
    min: roundUnit(chargeUnit.win.min, fractionDigits),
    mid: roundUnit(chargeUnit.win.mid, fractionDigits),
    max: roundUnit(chargeUnit.win.max, fractionDigits),
  },
})

const getSellPlanCalculationKey = (
  data: ISellPlansData,
  re100Opt = 'notAchieve'
) =>
  JSON.stringify({
    cust: data.cust,
    touVer: data.touVer,
    holidayYear: data.holidayYear,
    environmentalUnit: data.environmentalUnit,
    loadOpt: data.cust?.loadOpt || data.loadOpt || 'realTime',
    buyTOUList: data.buyTOUList,
    essPowerRate: data.essPowerRate,
    afterKEPCOContractedPower: data.afterKEPCOContractedPower,
    planType: data.planType,
    rateOpt: data.rateOpt,
    networkOpt: data.networkOpt,
    internalNetworkUnitBaseUnit: data.internalNetworkUnitBaseUnit,
    internalNetworkUnitPowerUnit: data.internalNetworkUnitPowerUnit,
    distributionUnitBaseUnit: data.distributionUnitBaseUnit,
    distributionUnitUsageUnit: data.distributionUnitUsageUnit,
    lossCostMinUnit: data.lossCostMinUnit,
    lossCostMidUnit: data.lossCostMidUnit,
    lossCostMaxUnit: data.lossCostMaxUnit,
    additionalSettlementUnit: data.additionalSettlementUnit,
    transactionCommissionUnit: data.transactionCommissionUnit,
    discountedPriceUnit: data.discountedPriceUnit,
    transmissionLossCostUnit: data.transmissionLossCostUnit,
    ectCostUnit: data.ectCostUnit,
    greenPremiumUnit: data.greenPremiumUnit,
    essProfitRate: data.essProfitRate,
    touPeriodResult: data.touPeriodResult,
    sprMinMidRate: data.sprMinMidRate,
    sprMinMaxRate: data.sprMinMaxRate,
    sumMinMidRate: data.sumMinMidRate,
    sumMinMaxRate: data.sumMinMaxRate,
    fallMinMidRate: data.fallMinMidRate,
    fallMinMaxRate: data.fallMinMaxRate,
    winMinMidRate: data.winMinMidRate,
    winMinMaxRate: data.winMinMaxRate,
    powerMarketTransactionUnit: data.powerMarketTransactionUnit,
  })

const getPlanTypeLabel = (planType: string) => {
  switch (planType) {
    case 'peakDeduction':
      return '최대부하 시간대 차감형 단일단가'
    case 'flat':
      return '모든 시간대 비율 차감형 단일단가'
    case 'tou':
      return '모든 시간대 비율 차감형 TOU'
    default:
      return '-'
  }
}

const getNetworkOptLabel = (networkOpt: string) => {
  switch (networkOpt) {
    case 'ignore':
      return '망비용 제외'
    case 'kepco':
      return '한전 송배전망 비용 반영'
    case 'internal':
      return '내부망 비용 반영'
    default:
      return networkOpt || '-'
  }
}

export const SellPlans = () => {
  const [sellTOUData, setSellTOUData] = useState<ISellPlansData>(
    initializeSellPlansData
  )
  const [activeWorkspaceTab, setActiveWorkspaceTab] =
    useState<SellPlanWorkspaceTab>('design')
  const workspaceBodyRef = useRef<HTMLDivElement>(null)
  const handleWorkspaceTabChange = useCallback((tab: SellPlanWorkspaceTab) => {
    setActiveWorkspaceTab(tab)

    if (tab === 'analysis') {
      requestAnimationFrame(() => {
        workspaceBodyRef.current?.scrollTo({ top: 0 })
      })
    }
  }, [])
  const { data: originLoadCusList } = useQuery(findAllLoadCustGQL)
  const [LoadCusList, setLoadCusList] = useState<any>()
  const effectiveLoadOpt =
    sellTOUData.cust?.loadOpt || sellTOUData.loadOpt || 'realTime'
  const { data: originDataUnit } = useQuery(findAllUnitDefaultGQL)
  const [dataUnit, setDataUnit] = useState<any>()
  const [buyTOUList, setBuyTOUList] = useState<buyTOUList[]>([] as buyTOUList[])
  const getSellUnitDefaultValues = useCallback((defaultData: any) => {
    if (!defaultData) return undefined

    return {
      touVer: defaultData.touVer ?? '',
      holidayYear: defaultData.holidayYear ?? '',
      environmentalUnit: defaultData.environmentalUnit ?? 0,
      internalNetworkUnitBaseUnit: defaultData.internalNetworkUnitBaseUnit,
      internalNetworkUnitPowerUnit: defaultData.internalNetworkUnitPowerUnit,
      distributionUnitBaseUnit: defaultData.distributionUnitBaseUnit,
      distributionUnitUsageUnit: defaultData.distributionUnitUsageUnit,
      lossCostMinUnit: defaultData.lossCostMinUnit,
      lossCostMidUnit: defaultData.lossCostMidUnit,
      lossCostMaxUnit: defaultData.lossCostMaxUnit,
      additionalSettlementUnit: defaultData.additionalSettlementUnit,
      transactionCommissionUnit: defaultData.transactionCommissionUnit,
      discountedPriceUnit: defaultData.discountedPriceUnit,
      transmissionLossCostUnit: defaultData.transmissionLossCostUnit,
      ectCostUnit: defaultData.ectCostUnit,
      greenPremiumUnit: defaultData.greenPremiumUnit ?? 11,
      powerMarketTransactionUnit: defaultData.powerMarketTransactionUnit,
    }
  }, [])

  const [isModify, setIsModify] = useState(false)
  const [isCheck, setIsCheck] = useState(false)
  const [
    isAfterKEPCOContractedPowerManuallyEdited,
    setIsAfterKEPCOContractedPowerManuallyEdited,
  ] = useState(false)
  const lastAppliedRecommendedEssPowerRate = useRef<number | null>(null)
  const isInitializingExistingSellPlan = useRef(false)
  const loadedChargeUnitResult = useRef<IChargeUnit | undefined>(undefined)
  const loadedCalculationKey = useRef<string | undefined>(undefined)

  const [findOneSellTOUData, { data: queryData, refetch }] = useLazyQuery(
    findOneSellTOUGQL,
    {
      fetchPolicy: 'network-only',
    }
  )

  const [findLoadData] = useLazyQuery(findLoadDataGQL)
  //수용가 데이터
  const [LoadData, setLoadData] = useState<any>()

  const [findLoadCustData] = useLazyQuery(findOneLoadcusGQL)
  //수용가 고객 데이터
  const [LoadCustData, setLoadCustData] = useState<any>()

  const [findKepcoData] = useLazyQuery(findOneKepcoTOUGQL)
  // 수용가 한전요금제
  const [kepcoData, setKepcoData] = useState<any>()
  // 모든 한전요금제(비율 계산용)
  const [allKepcoData, setAllKepcoData] = useState<any[]>([])

  const [findHolidaysData] = useLazyQuery(getHolidaysGQL)
  //공휴일 데이터
  const [holidaysData, setHolidaysData] = useState<any>()

  const [findPVData] = useLazyQuery(findPVDataGQL)
  const [findOnePurchasePlanData] = useLazyQuery(findOneBuyTOUGQL)

  // 한전 시간대
  const [touPeriodsData, setTouPeriodsData] = useState<any>()

  //PV 데이터 + buyTOUPlans 데이터
  const [buyTOUResults, setBuyTOUResults] = useState<any[]>([])

  const [createSellTOU] = useMutation(CreateSellTOUGQL)
  const [updateSellTOU] = useMutation(UpdateSellTOUGQL)
  const [deleteSellTOU] = useMutation(DeleteSellTOUGQL)

  const [planTypeRadioValue, setPlanTypeRadioValue] = useState('0')
  const [rateOptRadioValue, setRateOptRadioValue] = useState('0')
  const [networkOptRadioValue, setNetworkOptRadioValue] = useState('0')
  const [isTouRateSectionCollapsed, setIsTouRateSectionCollapsed] =
    useState(true)

  const [selectedPatternValue, setSelectedPatternValue] = useState('realTime')
  const [selectedMonths, setSelectedMonths] = useState<number[]>([])

  // 요금제 비율(sellTOUData에 따로 저장해버려서 다시 저장..)
  const [touRate, setTouRate] = useState<ITouRate>({
    spr: {
      minMid: 0,
      minMax: 0,
    },
    sum: {
      minMid: 0,
      minMax: 0,
    },
    fall: {
      minMid: 0,
      minMax: 0,
    },
    win: {
      minMid: 0,
      minMax: 0,
    },
  })

  // 옵션따라 고른 부하 데이터
  const [usingLoadData, setUsingLoadData] = useState<ITimeDataItem[]>([])

  // ESS 사업자에게 사올 부하 데이터
  const [ESSLoadData, setESSLoadData] = useState<ITimeDataItem[]>([])
  // 한전에게 사올 부하 데이터
  const [kepcoLoadData, seKepcoLoadData] = useState<ITimeDataItem[]>([])
  // 옵션따라 고른 부하 데이터 그래프용
  const [loadGraph, setLoadGraph] = useState<ITimeDataItem[]>([])

  // 구매-PV 계절별 발전량 및 발전 비용
  const [buyCost, setBuyCost] = useState<ISeasonalPVCharge>({
    spr: {
      pv: 0,
      charge: 0,
    },
    sum: {
      pv: 0,
      charge: 0,
    },
    fall: {
      pv: 0,
      charge: 0,
    },
    win: {
      pv: 0,
      charge: 0,
    },
  })

  const [buyCostList, setBuyCostList] = useState<
    {
      touId: string
      custId: string
      annualGeneration: number
      generationCost: number
    }[]
  >([])

  // 한전에 내던 기존 요금 (전체)
  const [kepcoSeasonCharge, setKepcoSeasonCharge] = useState<ISeasonalNum>({
    spr: 0,
    sum: 0,
    fall: 0,
    win: 0,
  })

  // 한전 요금제로 계산한 비율
  const [kepcoTouRate, setKepcoTouRate] = useState<ITouRate>({
    spr: {
      minMid: 0,
      minMax: 0,
    },
    sum: {
      minMid: 0,
      minMax: 0,
    },
    fall: {
      minMid: 0,
      minMax: 0,
    },
    win: {
      minMid: 0,
      minMax: 0,
    },
  })
  // 계절별 전력거래 합
  const [seasonalLoadSum, setSeasonalLoadSum] = useState<ISeasonalNum>({
    spr: 0,
    sum: 0,
    fall: 0,
    win: 0,
  })
  const [peakLoadSum, setPeakLoadSum] =
    useState<ISeasonalNum>(EMPTY_SEASONAL_NUM)
  //망 이용요금 단가 합
  const [gridUsageChargeUnitSum, setGridUsageChargeUnitSum] =
    useState<number>(0)

  // 망 이용요금 계산
  const [seasonalGridUsageCharge, setSeasonalGridUsageCharge] =
    useState<ISeasonalNum>({
      spr: 0,
      sum: 0,
      fall: 0,
      win: 0,
    })

  //계약전력 변경으로 절감될 기후 환경 요금 및 기본요금
  const [expectReduceCharge, setExpectReduceCharge] =
    useState<ISeasonalReduceCharge>({
      spr: {
        envCharge: 0,
        defaultCharge: 0,
      },
      sum: {
        envCharge: 0,
        defaultCharge: 0,
      },
      fall: {
        envCharge: 0,
        defaultCharge: 0,
      },
      win: {
        envCharge: 0,
        defaultCharge: 0,
      },
    })

  // 최종 결정된 요금 (한전+ESS)
  const [afterSeasonCharge, setAfterSeasonCharge] = useState<ISeasonalNum>({
    spr: 0,
    sum: 0,
    fall: 0,
    win: 0,
  })

  const [profitDelta, setProfitDelta] =
    useState<ISeasonalNum>(EMPTY_SEASONAL_NUM)
  const [planDiagnostic, setPlanDiagnostic] = useState<{
    beforeKepcoCharge: ISeasonalNum
    beforeGreenPremiumCharge: ISeasonalNum
    beforeCustomerCharge: ISeasonalNum
    afterKepcoCharge: ISeasonalNum
    remainingGreenPremiumCharge: ISeasonalNum
    afterKepcoOnlyCustomerCharge: ISeasonalNum
    maxCustomerPayment: ISeasonalNum
  } | null>(null)

  const greenPremiumUnit = sellTOUData.greenPremiumUnit ?? 0
  const re100Opt = LoadCustData?.re100Opt ?? 'notAchieve'
  const formatDefaultValue = (value: unknown, unit = '') => {
    if (value === null || value === undefined || value === '') return '-'

    return `${value}${unit}`
  }
  const isPeakDeductionSellPlan = sellTOUData.planType === 'peakDeduction'
  const beforeGreenPremiumCharge = calSeasonalExCharge(
    greenPremiumUnit,
    seasonalLoadSum
  )
  const beforeSeasonCharge =
    re100Opt === 'achieve'
      ? ISeasonalNumPlusISeasonalNum(
          kepcoSeasonCharge,
          beforeGreenPremiumCharge
        )
      : kepcoSeasonCharge
  const isCannotCreateSellPlan = sumSeasonalNum(profitDelta) < 0
  const annualLoadDemand = sumSeasonalNum(seasonalLoadSum)
  const annualPvGeneration = sumBuyCostGeneration(buyCost)
  const recommendedPowerPurchaseRate =
    annualLoadDemand > 0 ? (annualPvGeneration / annualLoadDemand) * 100 : 0
  const recommendedEssPowerRate = Math.min(
    100,
    Math.max(0, Math.floor(recommendedPowerPurchaseRate))
  )
  const recommendedAfterKEPCOContractedPower = Number(
    (
      ((LoadCustData?.prevKEPCOContractedPower ?? 0) *
        (100 - recommendedEssPowerRate)) /
      100
    ).toFixed(2)
  )
  const recommendedPowerPurchaseRateText =
    recommendedEssPowerRate.toLocaleString()
  const seasonalPvPurchaseCharge = SeasonalPVChargeToSeasonalCharge(buyCost)
  const diagnosticMinCharge = ISeasonalNumPlusISeasonalNum(
    seasonalPvPurchaseCharge,
    seasonalGridUsageCharge
  )
  const diagnosticAfterKepcoOnlyCharge =
    planDiagnostic?.afterKepcoOnlyCustomerCharge || EMPTY_SEASONAL_NUM
  const diagnosticMaxCharge =
    planDiagnostic?.maxCustomerPayment || EMPTY_SEASONAL_NUM
  const diagnosticGap = subtractPrevProfitToTradingCharge(
    diagnosticMaxCharge,
    diagnosticMinCharge
  )
  const diagnosticProfitShareCharge = ISeasonalNumMulNum(
    diagnosticGap,
    sellTOUData.essProfitRate / 100
  )
  const diagnosticCustomerSavingsCharge = subtractPrevProfitToTradingCharge(
    diagnosticGap,
    diagnosticProfitShareCharge
  )
  const diagnosticDesignedEssCharge = ISeasonalNumPlusISeasonalNum(
    diagnosticMinCharge,
    diagnosticProfitShareCharge
  )
  const diagnosticAfterCustomerCharge = ISeasonalNumPlusISeasonalNum(
    diagnosticDesignedEssCharge,
    diagnosticAfterKepcoOnlyCharge
  )
  const diagnosticMinChargeTotal = sumSeasonalNum(diagnosticMinCharge)
  const diagnosticGapTotal = sumSeasonalNum(diagnosticGap)
  const diagnosticAfterKepcoOnlyChargeTotal = sumSeasonalNum(
    diagnosticAfterKepcoOnlyCharge
  )
  const profitShareSensitivityData = useMemo<
    ProfitShareSensitivityPoint[]
  >(() => {
    const baseRates = Array.from({ length: 101 }, (_, index) => index)
    const rates = Array.from(
      new Set([...baseRates, sellTOUData.essProfitRate])
    ).sort((left, right) => left - right)
    const totalPurchaseGeneration = sumBuyCostGeneration(buyCost)

    return rates.map((essProfitRate) => {
      const essProfit = diagnosticGapTotal * (essProfitRate / 100)
      const customerSavings = diagnosticGapTotal - essProfit
      const designedEssCharge = diagnosticMinChargeTotal + essProfit

      return {
        essProfitRate,
        designedAverageSellUnit:
          totalPurchaseGeneration > 0
            ? designedEssCharge / totalPurchaseGeneration
            : 0,
        essProfit,
        customerSavings,
        afterCustomerCharge:
          designedEssCharge + diagnosticAfterKepcoOnlyChargeTotal,
      }
    })
  }, [
    buyCost,
    diagnosticAfterKepcoOnlyChargeTotal,
    diagnosticGapTotal,
    diagnosticMinChargeTotal,
    sellTOUData.essProfitRate,
  ])
  const showRecExcludedPurchaseWarning =
    re100Opt === 'achieve' &&
    buyTOUResults.some((item) => item?.plansdata?.recOpt === 'energyOnly')
  const showRecIncludedPurchaseWarning =
    re100Opt === 'notAchieve' &&
    buyTOUResults.some((item) => item?.plansdata?.recOpt === 'energyAndRec')
  const formatWon = (value: number) => Number(value.toFixed(0)).toLocaleString()
  const formatWonWithUnit = (value: number) => `${formatWon(value)}원`
  const formatKwh = (value: number) => Number(value.toFixed(2)).toLocaleString()
  const showCalculatedSellPlanResult = !isCannotCreateSellPlan
  const displayChargeUnitResult = showCalculatedSellPlanResult
    ? sellTOUData.chargeUnitResult
    : undefined
  const displayAfterSeasonCharge = showCalculatedSellPlanResult
    ? afterSeasonCharge
    : undefined
  const hasKepcoChargeUnit = Boolean(kepcoData?.chargeUnit)
  const peakKepcoMaxRate: ISeasonalNum = {
    spr: kepcoData?.chargeUnit?.spr?.max ?? 0,
    sum: kepcoData?.chargeUnit?.sum?.max ?? 0,
    fall: kepcoData?.chargeUnit?.fall?.max ?? 0,
    win: kepcoData?.chargeUnit?.win?.max ?? 0,
  }
  const formatChargeUnitResult = (value?: number) =>
    showCalculatedSellPlanResult ? value ?? 0 : '-'
  const formatFeasibilityUnit = (value: number | null | undefined) =>
    value === null || typeof value === 'undefined'
      ? '-'
      : `${value.toLocaleString(undefined, {
          maximumFractionDigits: 2,
        })} 원/kWh`
  const formatPeakKepcoRate = (value: number) =>
    hasKepcoChargeUnit ? value : '-'
  const selectedPurchasePlanText =
    buyTOUList
      .map((item) => item?.name)
      .filter(Boolean)
      .join(', ') || '-'
  const powerShareText = isPeakDeductionSellPlan
    ? '최대부하 시간대 우선 차감'
    : `ESS ${sellTOUData.essPowerRate}% / 한전 ${
        100 - sellTOUData.essPowerRate
      }%`
  const afterKepcoContractedPowerText = isPeakDeductionSellPlan
    ? '기존 계약전력 유지'
    : `${Number(
        sellTOUData.afterKEPCOContractedPower || 0
      ).toLocaleString()} kW`
  const profitShareText = `ESS 사업자 ${sellTOUData.essProfitRate}%`
  const networkConditionText = `${getNetworkOptLabel(
    sellTOUData.networkOpt
  )} / ${gridUsageChargeUnitSum.toLocaleString(undefined, {
    maximumFractionDigits: 2,
  })} 원/kWh`
  const re100ConditionText =
    re100Opt === 'achieve'
      ? `필요 / 녹색 프리미엄 ${Number(greenPremiumUnit).toLocaleString()} 원`
      : '해당 없음'
  const [sellPlanFeasibilityCurve, setSellPlanFeasibilityCurve] =
    useState<SellPlanUnitPriceCurve>({
      points: [],
      currentPurchaseAverageUnit: 0,
      currentTotalProfit: 0,
      currentTotalProfitRatio: null,
      unitPriceLimit: null,
      xMaxUnit: 1,
      feasible: false,
    })
  const [
    comparisonSellPlanFeasibilityCurve,
    setComparisonSellPlanFeasibilityCurve,
  ] = useState<SellPlanUnitPriceCurve | null>(null)
  const [isSellPlanFeasibilityLoading, setIsSellPlanFeasibilityLoading] =
    useState(false)
  const canAnalyzeSellPlanFeasibility =
    usingLoadData.length > 0 &&
    sumBuyCostGeneration(buyCost) > 0 &&
    Boolean(holidaysData) &&
    Boolean(touPeriodsData) &&
    Boolean(kepcoData?.chargeUnit) &&
    typeof kepcoData?.defaultChargeUnit !== 'undefined' &&
    Boolean(LoadCustData?.prevKEPCOContractedPower) &&
    (isPeakDeductionSellPlan ||
      (sellTOUData.essPowerRate > 0 &&
        sellTOUData.afterKEPCOContractedPower >= 0))
  const hasSellPlanFeasibilityResult =
    sellPlanFeasibilityCurve.points.length > 0
  const chartPrimaryFeasibilityLabel = isPeakDeductionSellPlan
    ? '최대부하 시간대 차감형'
    : '비율 차감형'
  const chartComparisonFeasibilityLabel = isPeakDeductionSellPlan
    ? '비율 차감형'
    : '최대부하 시간대 차감형'
  const peakDeductionFeasibilityCurve = isPeakDeductionSellPlan
    ? sellPlanFeasibilityCurve
    : comparisonSellPlanFeasibilityCurve
  const recommendedRatioFeasibilityCurve = isPeakDeductionSellPlan
    ? comparisonSellPlanFeasibilityCurve
    : sellPlanFeasibilityCurve
  const hasPeakDeductionFeasibilityResult = Boolean(
    peakDeductionFeasibilityCurve?.points.length
  )
  const hasRecommendedRatioFeasibilityResult = Boolean(
    recommendedRatioFeasibilityCurve?.points.length
  )
  const isPeakDeductionFeasibilityOverLimit =
    peakDeductionFeasibilityCurve?.unitPriceLimit !== null &&
    typeof peakDeductionFeasibilityCurve?.unitPriceLimit !== 'undefined' &&
    sellPlanFeasibilityCurve.currentPurchaseAverageUnit >
      (peakDeductionFeasibilityCurve?.unitPriceLimit ?? Infinity)
  const isRecommendedRatioFeasibilityOverLimit =
    recommendedRatioFeasibilityCurve?.unitPriceLimit !== null &&
    typeof recommendedRatioFeasibilityCurve?.unitPriceLimit !== 'undefined' &&
    sellPlanFeasibilityCurve.currentPurchaseAverageUnit >
      (recommendedRatioFeasibilityCurve?.unitPriceLimit ?? Infinity)
  const currentPurchaseAverageUnit =
    sellPlanFeasibilityCurve.currentPurchaseAverageUnit
  const peakDeductionUnitPriceLimit =
    peakDeductionFeasibilityCurve?.unitPriceLimit
  const recommendedRatioUnitPriceLimit =
    recommendedRatioFeasibilityCurve?.unitPriceLimit
  const currentFeasibilityMarkerPosition = 50
  const getFeasibilityLimitPosition = (
    value: number | null | undefined,
    hasResult: boolean
  ) => {
    if (
      !hasResult ||
      value === null ||
      typeof value === 'undefined' ||
      currentPurchaseAverageUnit <= 0
    ) {
      return 0
    }

    return Math.min(
      100,
      Math.max(
        0,
        (value / currentPurchaseAverageUnit) * currentFeasibilityMarkerPosition
      )
    )
  }
  const getFeasibilityFillWidth = (limitPosition: number) => limitPosition
  const getFeasibilityDifferenceText = (
    value: number | null | undefined,
    hasResult: boolean
  ) => {
    if (!hasResult || value === null || typeof value === 'undefined') {
      return '-'
    }

    const difference = Math.abs(value - currentPurchaseAverageUnit)
    const label = currentPurchaseAverageUnit > value ? '초과' : '여유'

    return `${label} ${difference.toLocaleString(undefined, {
      maximumFractionDigits: 2,
    })} 원/kWh`
  }
  const peakDeductionLimitPosition = getFeasibilityLimitPosition(
    peakDeductionUnitPriceLimit,
    hasPeakDeductionFeasibilityResult
  )
  const recommendedRatioLimitPosition = getFeasibilityLimitPosition(
    recommendedRatioUnitPriceLimit,
    hasRecommendedRatioFeasibilityResult
  )
  const sellPlanFeasibilitySummary = (
    <>
      <FeasibilitySummaryGrid>
        <FeasibilitySummaryCard>
          <FeasibilitySummaryLabel>
            최대부하 시간대 차감형
            <br />
            설계 가능 구매 평균단가
          </FeasibilitySummaryLabel>
          {isSellPlanFeasibilityLoading ? (
            <FeasibilityLoadingRow>
              <FeasibilitySpinner />
              계산 중
            </FeasibilityLoadingRow>
          ) : (
            <FeasibilitySummaryValue
              $accent
              $danger={isPeakDeductionFeasibilityOverLimit}
            >
              {hasPeakDeductionFeasibilityResult
                ? formatFeasibilityUnit(peakDeductionUnitPriceLimit)
                : '-'}
              {hasPeakDeductionFeasibilityResult &&
              peakDeductionUnitPriceLimit !== null ? (
                <FeasibilitySummarySuffix>이하</FeasibilitySummarySuffix>
              ) : null}
            </FeasibilitySummaryValue>
          )}
        </FeasibilitySummaryCard>
        <FeasibilitySummaryCard>
          <FeasibilitySummaryLabel>
            비율 차감형
            <br />
            설계 가능 구매 평균단가
          </FeasibilitySummaryLabel>
          {isSellPlanFeasibilityLoading ? (
            <FeasibilityLoadingRow>
              <FeasibilitySpinner />
              계산 중
            </FeasibilityLoadingRow>
          ) : (
            <FeasibilitySummaryValue
              $accent
              $danger={isRecommendedRatioFeasibilityOverLimit}
            >
              {hasRecommendedRatioFeasibilityResult
                ? formatFeasibilityUnit(recommendedRatioUnitPriceLimit)
                : '-'}
              {hasRecommendedRatioFeasibilityResult &&
              recommendedRatioUnitPriceLimit !== null ? (
                <FeasibilitySummarySuffix>이하</FeasibilitySummarySuffix>
              ) : null}
            </FeasibilitySummaryValue>
          )}
        </FeasibilitySummaryCard>
        <FeasibilitySummaryCard>
          <FeasibilitySummaryLabel>현재 구매 평균단가</FeasibilitySummaryLabel>
          {isSellPlanFeasibilityLoading ? (
            <FeasibilityLoadingRow>
              <FeasibilitySpinner />
              계산 중
            </FeasibilityLoadingRow>
          ) : (
            <FeasibilitySummaryValue $lower>
              {hasSellPlanFeasibilityResult
                ? formatFeasibilityUnit(currentPurchaseAverageUnit)
                : '-'}
            </FeasibilitySummaryValue>
          )}
        </FeasibilitySummaryCard>
      </FeasibilitySummaryGrid>
      <FeasibilityBarChart>
        <FeasibilityBarChartHeader>
          구매 평균단가 비교
        </FeasibilityBarChartHeader>
        <FeasibilityBarGuideRow>
          <FeasibilityCurrentLegendSpacer />
          <FeasibilityCurrentLegend $left={currentFeasibilityMarkerPosition}>
            <span>
              현재{' '}
              {hasSellPlanFeasibilityResult
                ? formatFeasibilityUnit(currentPurchaseAverageUnit)
                : '-'}
            </span>
          </FeasibilityCurrentLegend>
          <FeasibilityCurrentLegendSpacer />
        </FeasibilityBarGuideRow>
        <FeasibilityBarRow>
          <FeasibilityBarLabel>최대부하 시간대 차감형</FeasibilityBarLabel>
          <FeasibilityBarTrack>
            {hasPeakDeductionFeasibilityResult ? (
              <>
                <FeasibilityBarFill
                  $danger={isPeakDeductionFeasibilityOverLimit}
                  $left={0}
                  $width={getFeasibilityFillWidth(peakDeductionLimitPosition)}
                />
                <FeasibilityLimitMarker
                  $danger={isPeakDeductionFeasibilityOverLimit}
                  $left={peakDeductionLimitPosition}
                />
              </>
            ) : null}
            <FeasibilityCurrentMarker
              $left={currentFeasibilityMarkerPosition}
            />
          </FeasibilityBarTrack>
          <FeasibilityBarValue $danger={isPeakDeductionFeasibilityOverLimit}>
            {getFeasibilityDifferenceText(
              peakDeductionUnitPriceLimit,
              hasPeakDeductionFeasibilityResult
            )}
          </FeasibilityBarValue>
        </FeasibilityBarRow>
        <FeasibilityBarRow>
          <FeasibilityBarLabel>비율 차감형</FeasibilityBarLabel>
          <FeasibilityBarTrack>
            {hasRecommendedRatioFeasibilityResult ? (
              <>
                <FeasibilityBarFill
                  $danger={isRecommendedRatioFeasibilityOverLimit}
                  $left={0}
                  $width={getFeasibilityFillWidth(
                    recommendedRatioLimitPosition
                  )}
                />
                <FeasibilityLimitMarker
                  $danger={isRecommendedRatioFeasibilityOverLimit}
                  $left={recommendedRatioLimitPosition}
                />
              </>
            ) : null}
            <FeasibilityCurrentMarker
              $left={currentFeasibilityMarkerPosition}
            />
          </FeasibilityBarTrack>
          <FeasibilityBarValue $danger={isRecommendedRatioFeasibilityOverLimit}>
            {getFeasibilityDifferenceText(
              recommendedRatioUnitPriceLimit,
              hasRecommendedRatioFeasibilityResult
            )}
          </FeasibilityBarValue>
        </FeasibilityBarRow>
      </FeasibilityBarChart>
    </>
  )

  useEffect(() => {
    if (!canAnalyzeSellPlanFeasibility) {
      setIsSellPlanFeasibilityLoading(false)
      setSellPlanFeasibilityCurve({
        points: [],
        currentPurchaseAverageUnit: 0,
        currentTotalProfit: 0,
        currentTotalProfitRatio: null,
        unitPriceLimit: null,
        xMaxUnit: 1,
        feasible: false,
      })
      setComparisonSellPlanFeasibilityCurve(null)
      return
    }

    setIsSellPlanFeasibilityLoading(true)

    const timeoutId = window.setTimeout(() => {
      if (
        !holidaysData ||
        !touPeriodsData ||
        !kepcoData?.chargeUnit ||
        typeof kepcoData.defaultChargeUnit === 'undefined' ||
        !LoadCustData?.prevKEPCOContractedPower
      ) {
        setIsSellPlanFeasibilityLoading(false)
        return
      }

      const curve = isPeakDeductionSellPlan
        ? buildPeakDeductionSellPlanUnitPriceCurve({
            loadData: usingLoadData,
            buyCost,
            touPeriods: touPeriodsData,
            kepcoChargeUnit: kepcoData.chargeUnit,
            kepcoDefaultChargeUnit: kepcoData.defaultChargeUnit,
            contractedPower: LoadCustData.prevKEPCOContractedPower,
            environmentalUnit: sellTOUData.environmentalUnit,
            greenPremiumUnit,
            re100Opt,
            networkUnit: gridUsageChargeUnitSum,
            seasonMapping,
            holidayData: holidaysData,
          })
        : buildSellPlanUnitPriceCurve({
            loadData: usingLoadData,
            seasonalLoadSum,
            buyCost,
            gridUsageChargeUnitSum,
            kepcoSeasonCharge,
            touPeriods: touPeriodsData,
            kepcoChargeUnit: kepcoData.chargeUnit,
            kepcoDefaultChargeUnit: kepcoData.defaultChargeUnit,
            afterKEPCOContractedPower: sellTOUData.afterKEPCOContractedPower,
            essPowerRate: sellTOUData.essPowerRate,
            environmentalUnit: sellTOUData.environmentalUnit,
            greenPremiumUnit,
            re100Opt,
            seasonMapping,
            holidayData: holidaysData,
          })

      setSellPlanFeasibilityCurve(curve)
      setComparisonSellPlanFeasibilityCurve(
        isPeakDeductionSellPlan
          ? recommendedEssPowerRate > 0
            ? buildSellPlanUnitPriceCurve({
                loadData: usingLoadData,
                seasonalLoadSum,
                buyCost,
                gridUsageChargeUnitSum,
                kepcoSeasonCharge,
                touPeriods: touPeriodsData,
                kepcoChargeUnit: kepcoData.chargeUnit,
                kepcoDefaultChargeUnit: kepcoData.defaultChargeUnit,
                afterKEPCOContractedPower: recommendedAfterKEPCOContractedPower,
                essPowerRate: recommendedEssPowerRate,
                environmentalUnit: sellTOUData.environmentalUnit,
                greenPremiumUnit,
                re100Opt,
                seasonMapping,
                holidayData: holidaysData,
              })
            : null
          : buildPeakDeductionSellPlanUnitPriceCurve({
              loadData: usingLoadData,
              buyCost,
              touPeriods: touPeriodsData,
              kepcoChargeUnit: kepcoData.chargeUnit,
              kepcoDefaultChargeUnit: kepcoData.defaultChargeUnit,
              contractedPower: LoadCustData.prevKEPCOContractedPower,
              environmentalUnit: sellTOUData.environmentalUnit,
              greenPremiumUnit,
              re100Opt,
              networkUnit: gridUsageChargeUnitSum,
              seasonMapping,
              holidayData: holidaysData,
            })
      )
      setIsSellPlanFeasibilityLoading(false)
    }, 80)

    return () => {
      window.clearTimeout(timeoutId)
    }
  }, [
    canAnalyzeSellPlanFeasibility,
    holidaysData,
    touPeriodsData,
    kepcoData,
    LoadCustData?.prevKEPCOContractedPower,
    usingLoadData,
    seasonalLoadSum,
    buyCost,
    gridUsageChargeUnitSum,
    kepcoSeasonCharge,
    sellTOUData.afterKEPCOContractedPower,
    sellTOUData.essPowerRate,
    sellTOUData.environmentalUnit,
    greenPremiumUnit,
    re100Opt,
    isPeakDeductionSellPlan,
    recommendedEssPowerRate,
    recommendedAfterKEPCOContractedPower,
  ])

  const [listRefetch, setListRefetch] = useState<() => void>(() => () => {})

  const handleRefetch = useCallback(() => {
    if (listRefetch) {
      listRefetch()
    }
  }, [listRefetch])

  const calculateAfterKEPCOContractedPower = useCallback(
    (essPowerRate: number) => {
      const prevContractedPower = Number(
        LoadCustData?.prevKEPCOContractedPower ?? 0
      )
      const kepcoPowerRate = 100 - essPowerRate

      return Number(((prevContractedPower * kepcoPowerRate) / 100).toFixed(2))
    },
    [LoadCustData?.prevKEPCOContractedPower]
  )

  const handleFindOne = (...args: Parameters<typeof findOneSellTOUData>) => {
    setActiveWorkspaceTab('design')
    findOneSellTOUData(...args)
  }

  useEffect(() => {
    if (queryData && queryData.findOneSellTOU) {
      const { __typename, ...rest } = queryData.findOneSellTOU

      const loadedSellPlan = {
        ...initializeSellPlansData(),
        ...rest,
        planType: rest.planType ?? 'tou',
        ...(dataUnit || {}),
      }

      loadedChargeUnitResult.current = loadedSellPlan.chargeUnitResult
      loadedCalculationKey.current = getSellPlanCalculationKey(
        loadedSellPlan,
        rest.cust?.re100Opt ?? 'notAchieve'
      )
      setSellTOUData(loadedSellPlan)
      isInitializingExistingSellPlan.current = true
    }
  }, [queryData, dataUnit])

  useEffect(() => {
    if (
      isPeakDeductionSellPlan ||
      annualLoadDemand <= 0 ||
      annualPvGeneration <= 0 ||
      Number(LoadCustData?.prevKEPCOContractedPower ?? 0) <= 0
    ) {
      return
    }

    if (sellTOUData._id && isInitializingExistingSellPlan.current) {
      lastAppliedRecommendedEssPowerRate.current = recommendedEssPowerRate
      isInitializingExistingSellPlan.current = false
      return
    }

    if (
      lastAppliedRecommendedEssPowerRate.current === recommendedEssPowerRate
    ) {
      return
    }

    lastAppliedRecommendedEssPowerRate.current = recommendedEssPowerRate
    setSellTOUData((prev) => ({
      ...prev,
      essPowerRate: recommendedEssPowerRate,
      ...(isAfterKEPCOContractedPowerManuallyEdited
        ? {}
        : {
            afterKEPCOContractedPower: calculateAfterKEPCOContractedPower(
              recommendedEssPowerRate
            ),
          }),
    }))
  }, [
    isPeakDeductionSellPlan,
    sellTOUData._id,
    annualLoadDemand,
    annualPvGeneration,
    recommendedEssPowerRate,
    isAfterKEPCOContractedPowerManuallyEdited,
    LoadCustData?.prevKEPCOContractedPower,
    calculateAfterKEPCOContractedPower,
  ])

  // 부하 선택
  useEffect(() => {
    if (LoadData) {
      const tmpData = divTimeData(LoadData, 1000)

      switch (effectiveLoadOpt) {
        case 'aver':
          const monthRepPatternAver = calMonthRepPattern(tmpData, 'aver')
          setUsingLoadData(monthRepPatternAver.repData)
          setLoadGraph(monthRepPatternAver.graphData)

          break
        case 'mid':
          const monthRepPatternMid = calMonthRepPattern(tmpData, 'mid')
          setUsingLoadData(monthRepPatternMid.repData)
          setLoadGraph(monthRepPatternMid.graphData)

          break
        case 'mode':
          const monthRepPatternMode = calMonthRepPattern(tmpData, 'mode')
          setUsingLoadData(monthRepPatternMode.repData)
          setLoadGraph(monthRepPatternMode.graphData)

          break

        case 'realTime':
          setUsingLoadData(tmpData)
          setLoadGraph(tmpData)

          break
      }
    }
  }, [effectiveLoadOpt, LoadData])

  //계절별 전력거래 합 구하기
  useEffect(() => {
    if (usingLoadData) {
      // LoadData 직접 수정이 안되어서 복사
      const tmpData = JSON.parse(JSON.stringify(usingLoadData))
      const a = calSeasonalSum(tmpData, seasonMapping)
      setSeasonalLoadSum(a)
    }
  }, [usingLoadData])

  // 최대부하 시간대 수용가 부하 합계 구하기
  useEffect(() => {
    if (
      usingLoadData.length === 0 ||
      !holidaysData ||
      holidaysData.length === 0 ||
      !touPeriodsData
    ) {
      setPeakLoadSum(EMPTY_SEASONAL_NUM)
      return
    }

    const monthLoadTimeSum = calLoadTimeSum(
      usingLoadData,
      seasonMapping,
      holidaysData,
      touPeriodsData
    ).loadTimeSumResult
    const seasonLoadTimeSum = monthLoadTimeToSeasonLoadTime(
      monthLoadTimeSum,
      seasonMapping
    )

    setPeakLoadSum({
      spr: seasonLoadTimeSum.spr.max,
      sum: seasonLoadTimeSum.sum.max,
      fall: seasonLoadTimeSum.fall.max,
      win: seasonLoadTimeSum.win.max,
    })
  }, [usingLoadData, holidaysData, touPeriodsData])

  // 구매-연간 발전량 및 발전 비용 계산
  useEffect(() => {
    if (buyTOUResults.length === 0) {
      setBuyCost({
        spr: { pv: 0, charge: 0 },
        sum: { pv: 0, charge: 0 },
        fall: { pv: 0, charge: 0 },
        win: { pv: 0, charge: 0 },
      })
      setBuyCostList([])
      return
    }

    if (holidaysData && holidaysData.length !== 0) {
      const result = {
        spr: {
          pv: 0,
          charge: 0,
        },
        sum: {
          pv: 0,
          charge: 0,
        },
        fall: {
          pv: 0,
          charge: 0,
        },
        win: {
          pv: 0,
          charge: 0,
        },
      }

      setBuyCostList([])
      const tmpList = []
      for (let index = 0; index < buyTOUResults.length; index++) {
        //pv 1개에 대해
        const element = buyTOUResults[index]
        if (element.plansdata !== '') {
          // const touId = element.plansdata._id
          // const custId = element.plansdata.cust._id
          const touId = element.selectedTouId // (O)
          const custId = element.selectedCustId // (O)
          if (element.pvdata && element.plansdata) {
            // 발전량
            const pvdata = divTimeData(element.pvdata, 1000)
            const monthPVSum = calSeasonalSum(pvdata, seasonMapping)
            result.spr.pv += monthPVSum.spr
            result.sum.pv += monthPVSum.sum
            result.fall.pv += monthPVSum.fall
            result.win.pv += monthPVSum.win

            const annualGeneration =
              monthPVSum.spr + monthPVSum.sum + monthPVSum.fall + monthPVSum.win

            //요금
            if (
              element.plansdata.chargeUnitResult &&
              element.plansdata.touPeriodResult
            ) {
              const chargeUnitResult = element.plansdata.chargeUnitResult
              const touPeriodResult = element.plansdata.touPeriodResult

              const monthlyCharge = calMonthlyChargeAsUsage(
                pvdata,
                touPeriodResult,
                chargeUnitResult,
                seasonMapping,
                holidaysData
              )

              const seasonalCharge = monthSumToSeasonSum(
                monthlyCharge,
                seasonMapping
              )

              result.spr.charge += seasonalCharge.spr
              result.sum.charge += seasonalCharge.sum
              result.fall.charge += seasonalCharge.fall
              result.win.charge += seasonalCharge.win

              const generationCost =
                seasonalCharge.spr +
                seasonalCharge.sum +
                seasonalCharge.fall +
                seasonalCharge.win

              tmpList.push({
                touId: touId,
                custId: custId,
                annualGeneration: annualGeneration,
                generationCost: generationCost,
              })
            }
          }
        }
      }
      //FIXME: 테스트용
      const averPv =
        (result.spr.pv + result.sum.pv + result.fall.pv + result.win.pv) / 4
      const averCharge =
        (result.spr.charge +
          result.sum.charge +
          result.fall.charge +
          result.win.charge) /
        4

      setBuyCost(result)
      setBuyCostList(tmpList)
    }
  }, [buyTOUResults, holidaysData])

  // 한전에 내던 기존 요금 계산하기
  useEffect(() => {
    if (
      usingLoadData.length !== 0 &&
      kepcoData &&
      holidaysData &&
      holidaysData.length !== 0 &&
      touPeriodsData &&
      LoadCustData &&
      LoadCustData.length !== 0
    ) {
      const monthlyResult = calKepcoMonthlyChargeAsUsage(
        usingLoadData,
        touPeriodsData,
        kepcoData.chargeUnit,
        seasonMapping,
        holidaysData,
        kepcoData.defaultChargeUnit,
        LoadCustData.prevKEPCOContractedPower,
        sellTOUData.environmentalUnit
      )

      const seasonResult = monthSumToSeasonSum(monthlyResult, seasonMapping)
      setKepcoSeasonCharge(seasonResult)
    }
  }, [
    usingLoadData,
    kepcoData,
    holidaysData,
    touPeriodsData,
    LoadCustData,
    sellTOUData.environmentalUnit,
  ])

  // [수정] 비율에 따른 부하데이터 세팅 (0%일 때도 데이터 생성되도록 조건 완화)
  useEffect(() => {
    if (usingLoadData && usingLoadData.length !== 0) {
      if (isPeakDeductionSellPlan) {
        if (!holidaysData || !touPeriodsData) return

        const peakDeductionLoadData = buildPeakDeductionLoadData({
          loadData: usingLoadData,
          totalPvGeneration: sumBuyCostGeneration(buyCost),
          seasonMapping,
          holidayData: holidaysData,
          touPeriods: touPeriodsData,
        })

        setESSLoadData(peakDeductionLoadData.essLoadData)
        seKepcoLoadData(peakDeductionLoadData.kepcoLoadData)
        return
      }

      const essRate = sellTOUData.essPowerRate / 100
      const kepcoRate = 1 - essRate

      const essTimeData = mulTimeData(usingLoadData, essRate)
      const kepcoTimeData = mulTimeData(usingLoadData, kepcoRate)

      setESSLoadData(essTimeData)
      seKepcoLoadData(kepcoTimeData)
    }
  }, [
    usingLoadData,
    sellTOUData.essPowerRate,
    isPeakDeductionSellPlan,
    holidaysData,
    touPeriodsData,
    buyCost,
  ])

  //예상 절감비용 계산
  useEffect(() => {
    if (isPeakDeductionSellPlan) {
      setExpectReduceCharge({
        spr: { envCharge: 0, defaultCharge: 0 },
        sum: { envCharge: 0, defaultCharge: 0 },
        fall: { envCharge: 0, defaultCharge: 0 },
        win: { envCharge: 0, defaultCharge: 0 },
      })
      return
    }

    if (
      kepcoData?.defaultChargeUnit &&
      sellTOUData.environmentalUnit &&
      LoadCustData?.prevKEPCOContractedPower &&
      sellTOUData.afterKEPCOContractedPower &&
      ESSLoadData.length !== 0
    ) {
      // 계절별 부하 합 감소량
      const reduceLoad = monthSumToSeasonSum(
        calMonthSum(ESSLoadData),
        seasonMapping
      )

      // 예상 절감비용 계산
      const result = calReduceCharge(
        kepcoData.defaultChargeUnit,
        sellTOUData.environmentalUnit,
        LoadCustData.prevKEPCOContractedPower,
        sellTOUData.afterKEPCOContractedPower,
        reduceLoad,
        seasonMapping
      )
      setExpectReduceCharge(result)
    }
  }, [
    kepcoData?.defaultChargeUnit,
    sellTOUData.essPowerRate,
    sellTOUData.environmentalUnit,
    sellTOUData.afterKEPCOContractedPower,
    LoadCustData?.prevKEPCOContractedPower,
    ESSLoadData,
    isPeakDeductionSellPlan,
  ])

  // [추가] 가격 비율 옵션(rateOpt)이 변경되면 라디오 버튼 UI도 동기화
  useEffect(() => {
    switch (sellTOUData.rateOpt) {
      case 'flat':
      case 'single':
        setRateOptRadioValue('1')
        break
      case 'userInput':
        setRateOptRadioValue('2')
        break
      case 'kepco':
      default:
        setRateOptRadioValue('0')
        break
    }
  }, [sellTOUData.rateOpt])

  useEffect(() => {
    if (sellTOUData.planType === 'flat') {
      setPlanTypeRadioValue('2')
    } else if (sellTOUData.planType === 'peakDeduction') {
      setPlanTypeRadioValue('0')
    } else {
      setPlanTypeRadioValue('1')
    }
  }, [sellTOUData.planType])

  // 가격비율 설정
  useEffect(() => {
    switch (sellTOUData.rateOpt) {
      case 'flat':
      case 'single':
        setSellTOUData((prevData) => ({
          ...prevData,
          sprMinMidRate: 1,
          sumMinMidRate: 1,
          fallMinMidRate: 1,
          winMinMidRate: 1,
          sprMinMaxRate: 1,
          sumMinMaxRate: 1,
          fallMinMaxRate: 1,
          winMinMaxRate: 1,
        }))

        break
      case 'userInput':
        break
      case 'kepco':
      default:
        if (allKepcoData && allKepcoData.length !== 0) {
          setSellTOUData((prevData) => ({
            ...prevData,
            sprMinMidRate: kepcoTouRate.spr.minMid,
            sumMinMidRate: kepcoTouRate.sum.minMid,
            fallMinMidRate: kepcoTouRate.fall.minMid,
            winMinMidRate: kepcoTouRate.win.minMid,
            sprMinMaxRate: kepcoTouRate.spr.minMax,
            sumMinMaxRate: kepcoTouRate.sum.minMax,
            fallMinMaxRate: kepcoTouRate.fall.minMax,
            winMinMaxRate: kepcoTouRate.win.minMax,
          }))
        }
        break
    }
  }, [sellTOUData.rateOpt, sellTOUData.touVer, kepcoTouRate])

  useEffect(() => {
    if (allKepcoData.length !== 0) {
      setKepcoTouRate(calKepcoAverage(allKepcoData))
    }
  }, [allKepcoData])

  //touRate 세팅
  useEffect(() => {
    const hasAllTouRates = [
      sellTOUData.sprMinMidRate,
      sellTOUData.sprMinMaxRate,
      sellTOUData.sumMinMidRate,
      sellTOUData.sumMinMaxRate,
      sellTOUData.fallMinMidRate,
      sellTOUData.fallMinMaxRate,
      sellTOUData.winMinMidRate,
      sellTOUData.winMinMaxRate,
    ].every((rate) => typeof rate === 'number' && !Number.isNaN(rate))

    if (hasAllTouRates) {
      const {
        sprMinMidRate,
        sprMinMaxRate,
        sumMinMidRate,
        sumMinMaxRate,
        fallMinMidRate,
        fallMinMaxRate,
        winMinMidRate,
        winMinMaxRate,
      } = sellTOUData as Required<
        Pick<
          ISellPlansData,
          | 'sprMinMidRate'
          | 'sprMinMaxRate'
          | 'sumMinMidRate'
          | 'sumMinMaxRate'
          | 'fallMinMidRate'
          | 'fallMinMaxRate'
          | 'winMinMidRate'
          | 'winMinMaxRate'
        >
      >

      const tmpTouRate: ITouRate = {
        spr: {
          minMid: sprMinMidRate,
          minMax: sprMinMaxRate,
        },
        sum: {
          minMid: sumMinMidRate,
          minMax: sumMinMaxRate,
        },
        fall: {
          minMid: fallMinMidRate,
          minMax: fallMinMaxRate,
        },
        win: {
          minMid: winMinMidRate,
          minMax: winMinMaxRate,
        },
      }

      setTouRate(tmpTouRate)
    }
  }, [
    sellTOUData.sprMinMidRate,
    sellTOUData.sprMinMaxRate,
    sellTOUData.sumMinMidRate,
    sellTOUData.sumMinMaxRate,
    sellTOUData.fallMinMidRate,
    sellTOUData.fallMinMaxRate,
    sellTOUData.winMinMidRate,
    sellTOUData.winMinMaxRate,
  ])

  // 망 이용요금 단가 합 계산
  useEffect(() => {
    if (sellTOUData.networkOpt === 'kepco') {
      if (
        typeof sellTOUData.distributionUnitBaseUnit !== 'undefined' &&
        typeof sellTOUData.distributionUnitUsageUnit !== 'undefined' &&
        typeof sellTOUData.lossCostMinUnit !== 'undefined' &&
        typeof sellTOUData.lossCostMidUnit !== 'undefined' &&
        typeof sellTOUData.lossCostMaxUnit !== 'undefined' &&
        typeof sellTOUData.additionalSettlementUnit !== 'undefined' &&
        typeof sellTOUData.transactionCommissionUnit !== 'undefined' &&
        typeof sellTOUData.transmissionLossCostUnit !== 'undefined' &&
        typeof sellTOUData.ectCostUnit !== 'undefined' &&
        typeof sellTOUData.discountedPriceUnit !== 'undefined'
      ) {
        const unit =
          sellTOUData.distributionUnitBaseUnit +
          sellTOUData.distributionUnitUsageUnit +
          sellTOUData.lossCostMinUnit +
          sellTOUData.lossCostMidUnit +
          sellTOUData.lossCostMaxUnit +
          sellTOUData.additionalSettlementUnit +
          sellTOUData.transactionCommissionUnit +
          sellTOUData.transmissionLossCostUnit +
          sellTOUData.ectCostUnit -
          sellTOUData.discountedPriceUnit
        setGridUsageChargeUnitSum(unit)
      } else setGridUsageChargeUnitSum(0)
    } else if (sellTOUData.networkOpt === 'internal') {
      if (
        typeof sellTOUData.internalNetworkUnitBaseUnit !== 'undefined' &&
        typeof sellTOUData.internalNetworkUnitPowerUnit !== 'undefined' &&
        typeof sellTOUData.ectCostUnit !== 'undefined'
      ) {
        const unit =
          sellTOUData.internalNetworkUnitBaseUnit +
          sellTOUData.internalNetworkUnitPowerUnit +
          sellTOUData.ectCostUnit
        setGridUsageChargeUnitSum(unit)
      } else setGridUsageChargeUnitSum(0)
    } else if (sellTOUData.networkOpt === 'ignore') {
      setGridUsageChargeUnitSum(0)
    }
  }, [
    sellTOUData.internalNetworkUnitBaseUnit,
    sellTOUData.internalNetworkUnitPowerUnit,
    sellTOUData.distributionUnitBaseUnit,
    sellTOUData.distributionUnitUsageUnit,
    sellTOUData.lossCostMinUnit,
    sellTOUData.lossCostMidUnit,
    sellTOUData.lossCostMaxUnit,
    sellTOUData.additionalSettlementUnit,
    sellTOUData.transactionCommissionUnit,
    sellTOUData.discountedPriceUnit,
    sellTOUData.transmissionLossCostUnit,
    sellTOUData.ectCostUnit,
    sellTOUData.networkOpt,
  ])

  //망 이용요금 계산
  useEffect(() => {
    if (typeof gridUsageChargeUnitSum !== 'undefined' && seasonalLoadSum) {
      const targetUsage = isPeakDeductionSellPlan
        ? monthSumToSeasonSum(calMonthSum(ESSLoadData), seasonMapping)
        : seasonalLoadSum
      const a = calSeasonalExCharge(gridUsageChargeUnitSum, targetUsage)
      setSeasonalGridUsageCharge(a)
    }
  }, [
    gridUsageChargeUnitSum,
    seasonalLoadSum,
    networkOptRadioValue,
    isPeakDeductionSellPlan,
    ESSLoadData,
  ])

  //최종 요금제 계산
  useEffect(() => {
    if (
      buyCost &&
      seasonalGridUsageCharge &&
      ESSLoadData.length !== 0 &&
      holidaysData &&
      kepcoData &&
      touPeriodsData
    ) {
      if (isPeakDeductionSellPlan) {
        if (!LoadCustData?.prevKEPCOContractedPower) return

        const peakDeductionResult = calPeakDeductionSellPlan({
          loadData: usingLoadData,
          buyCost,
          touPeriods: touPeriodsData,
          kepcoChargeUnit: kepcoData.chargeUnit,
          defaultChargeUnit: kepcoData.defaultChargeUnit,
          environmentalUnit: sellTOUData.environmentalUnit,
          contractedPower: LoadCustData.prevKEPCOContractedPower,
          seasonMapping,
          holidayData: holidaysData,
          networkUnit: gridUsageChargeUnitSum,
          essProfitRate: sellTOUData.essProfitRate,
          greenPremiumUnit,
          re100Opt,
        })

        setProfitDelta({
          spr: peakDeductionResult.profitPool,
          sum: 0,
          fall: 0,
          win: 0,
        })

        const peakBeforeKepcoCharge = monthSumToSeasonSum(
          peakDeductionResult.beforeKepcoCharge,
          seasonMapping
        )
        const peakBeforeCustomerCharge = monthSumToSeasonSum(
          peakDeductionResult.beforeCustomerCharge,
          seasonMapping
        )
        const peakAfterKepcoOnlyCustomerCharge = monthSumToSeasonSum(
          peakDeductionResult.afterKepcoOnlyCustomerCharge,
          seasonMapping
        )
        const peakBeforeGreenPremiumCharge = subtractPrevProfitToTradingCharge(
          peakBeforeCustomerCharge,
          peakBeforeKepcoCharge
        )
        const peakMaxCustomerPayment = subtractPrevProfitToTradingCharge(
          peakBeforeCustomerCharge,
          peakAfterKepcoOnlyCustomerCharge
        )

        setPlanDiagnostic({
          beforeKepcoCharge: peakBeforeKepcoCharge,
          beforeGreenPremiumCharge: peakBeforeGreenPremiumCharge,
          beforeCustomerCharge: peakBeforeCustomerCharge,
          afterKepcoCharge: monthSumToSeasonSum(
            peakDeductionResult.afterKepcoCharge,
            seasonMapping
          ),
          remainingGreenPremiumCharge: monthSumToSeasonSum(
            peakDeductionResult.remainingGreenPremiumCharge,
            seasonMapping
          ),
          afterKepcoOnlyCustomerCharge: peakAfterKepcoOnlyCustomerCharge,
          maxCustomerPayment: peakMaxCustomerPayment,
        })

        if (!peakDeductionResult.isFeasible) {
          return
        }

        const shouldKeepLoadedChargeUnit =
          loadedChargeUnitResult.current &&
          loadedCalculationKey.current ===
            getSellPlanCalculationKey(sellTOUData, re100Opt)
        const chargeUnitResult = shouldKeepLoadedChargeUnit
          ? loadedChargeUnitResult.current ??
            roundChargeUnitResult(peakDeductionResult.chargeUnitResult, 1)
          : roundChargeUnitResult(peakDeductionResult.chargeUnitResult, 1)
        setSellTOUData((prevData) => ({
          ...prevData,
          chargeUnitResult,
        }))

        const essCharge = monthSumToSeasonSum(
          peakDeductionResult.afterEssCharge,
          seasonMapping
        )
        const kepcoCharge = monthSumToSeasonSum(
          peakDeductionResult.afterKepcoCharge,
          seasonMapping
        )
        const remainingGreenPremiumCharge = monthSumToSeasonSum(
          peakDeductionResult.remainingGreenPremiumCharge,
          seasonMapping
        )

        setAfterSeasonCharge(
          ISeasonalNumPlusISeasonalNum(
            ISeasonalNumPlusISeasonalNum(essCharge, kepcoCharge),
            remainingGreenPremiumCharge
          )
        )
        return
      }

      // 계약 이전 전체 요금과 계약 이후 남은 한전 부담 사이에서 ESS 요금을 산정
      const seasonalMin = ISeasonalNumPlusISeasonalNum(
        SeasonalPVChargeToSeasonalCharge(buyCost),
        seasonalGridUsageCharge
      )
      const greenPremiumBefore = calSeasonalExCharge(
        greenPremiumUnit,
        seasonalLoadSum
      )
      const beforeCustomerCharge =
        re100Opt === 'achieve'
          ? ISeasonalNumPlusISeasonalNum(kepcoSeasonCharge, greenPremiumBefore)
          : kepcoSeasonCharge
      const afterKepcoMonthlyCharge = calKepcoMonthlyChargeAsUsage(
        kepcoLoadData,
        touPeriodsData,
        kepcoData.chargeUnit,
        seasonMapping,
        holidaysData,
        kepcoData.defaultChargeUnit,
        sellTOUData.afterKEPCOContractedPower,
        sellTOUData.environmentalUnit
      )
      const afterKepcoCharge = monthSumToSeasonSum(
        afterKepcoMonthlyCharge,
        seasonMapping
      )
      const remainingGreenPremiumCharge =
        re100Opt === 'achieve'
          ? calSeasonalExCharge(
              greenPremiumUnit,
              monthSumToSeasonSum(calMonthSum(kepcoLoadData), seasonMapping)
            )
          : EMPTY_SEASONAL_NUM
      const afterKepcoOnlyCustomerCharge = ISeasonalNumPlusISeasonalNum(
        afterKepcoCharge,
        remainingGreenPremiumCharge
      )
      const seasonalMax = subtractPrevProfitToTradingCharge(
        beforeCustomerCharge,
        afterKepcoOnlyCustomerCharge
      )

      setPlanDiagnostic({
        beforeKepcoCharge: kepcoSeasonCharge,
        beforeGreenPremiumCharge:
          re100Opt === 'achieve' ? greenPremiumBefore : EMPTY_SEASONAL_NUM,
        beforeCustomerCharge,
        afterKepcoCharge,
        remainingGreenPremiumCharge,
        afterKepcoOnlyCustomerCharge,
        maxCustomerPayment: seasonalMax,
      })

      // console.log('원래 한전에 내던 돈(총 요금)', kepcoSeasonCharge)
      // console.log(
      //   '줄 수 있는 최대값(ess분을 한전요금으로 계산)',
      //   EssSeasonCharge
      // )
      // console.log('PV 구매비용', SeasonalPVChargeToSeasonalCharge(buyCost))
      // console.log('망 이용요금', seasonalGridUsageCharge)
      // console.log('최소값', seasonalMin)

      const totalProfit = subtractPrevProfitToTradingCharge(
        seasonalMax,
        seasonalMin
      )
      setProfitDelta(totalProfit)
      // console.log('전체이익(최대-최소)', totalProfit)

      if (sumSeasonalNum(totalProfit) < 0) {
        return
      }

      //ESSLoadData로 계산한 계절별 최저중간최대부하 계산
      const kepcoMonthCharge = calLoadTimeSum(
        ESSLoadData,
        seasonMapping,
        holidaysData,
        touPeriodsData
      ).loadTimeSumResult

      const kepcoSeasonLoadTimeCharge = monthLoadTimeToSeasonLoadTime(
        kepcoMonthCharge,
        seasonMapping
      )
      // console.log('계절별 최저중간최대부하', kepcoSeasonLoadTimeCharge)

      const profitForPlan = ISeasonalNumMulNum(
        totalProfit,
        sellTOUData.essProfitRate / 100
      )

      const custRevenue = ISeasonalNumPlusISeasonalNum(
        profitForPlan,
        seasonalMin
      )

      // console.log('요금제 결정되는 값', custRevenue)

      // 요금제 계산
      const calculatedTouUnit =
        sellTOUData.planType === 'flat'
          ? calFlatTouUnitCharge(kepcoSeasonLoadTimeCharge, custRevenue)
          : calTouUnitCharge(
              touRate,
              calMinChargeUnit(touRate, kepcoSeasonLoadTimeCharge, custRevenue)
            )
      const shouldKeepLoadedChargeUnit =
        loadedChargeUnitResult.current &&
        loadedCalculationKey.current ===
          getSellPlanCalculationKey(sellTOUData, re100Opt)
      const touUnit = shouldKeepLoadedChargeUnit
        ? loadedChargeUnitResult.current ??
          roundChargeUnitResult(calculatedTouUnit, 1)
        : roundChargeUnitResult(calculatedTouUnit, 1)
      // console.log('요금제', touUnit)
      setSellTOUData((prevData) => ({
        ...prevData,
        chargeUnitResult: touUnit,
      }))

      // 변경 후 요금 계산 (ESS요금 + 한전요금)
      const essCharge = monthSumToSeasonSum(
        calMonthlyChargeAsUsage(
          ESSLoadData,
          touPeriodsData,
          touUnit,
          seasonMapping,
          holidaysData
        ),
        seasonMapping
      )
      // console.log('ESS 사업자 요금', essCharge)

      // console.log('ESS 랑 나눠먹고 다시 계산한 한전 요금', kepcoCharge)

      setAfterSeasonCharge(
        ISeasonalNumPlusISeasonalNum(
          ISeasonalNumPlusISeasonalNum(essCharge, afterKepcoCharge),
          remainingGreenPremiumCharge
        )
      )

      // console.log('합', ISeasonalNumPlusISeasonalNum(essCharge, kepcoCharge))
    }
  }, [
    buyCost,
    seasonalGridUsageCharge,
    ESSLoadData,
    holidaysData,
    sellTOUData.essProfitRate,
    re100Opt,
    greenPremiumUnit,
    seasonalLoadSum,
    kepcoSeasonCharge,
    kepcoData,
    kepcoLoadData,
    touRate,
    touPeriodsData,
    sellTOUData.planType,
    sellTOUData.afterKEPCOContractedPower,
    sellTOUData.environmentalUnit,
    isPeakDeductionSellPlan,
    LoadCustData,
    usingLoadData,
    gridUsageChargeUnitSum,
  ])

  useEffect(() => {
    handleResetAll()
  }, [])

  // TODO: 뭐하는 코드인지 모르겠음..
  useEffect(() => {
    setIsModify(!!sellTOUData._id)
    setBuyTOUList(sellTOUData.buyTOUList)
  }, [sellTOUData._id])

  useEffect(() => {
    if (originLoadCusList) setLoadCusList(Object.values(originLoadCusList)[0])
  }, [originLoadCusList])

  useEffect(() => {
    if (originDataUnit?.findAllUnitDefault[0]) {
      const { __typename, _id, ...less } = originDataUnit.findAllUnitDefault[0]
      setDataUnit(getSellUnitDefaultValues(less))
    }
  }, [originDataUnit, getSellUnitDefaultValues])

  useEffect(() => {
    setSellTOUData((prev) => {
      const updatedDataUnit = { ...prev, ...dataUnit }
      return updatedDataUnit
    })
  }, [dataUnit])

  useEffect(() => {
    if (!sellTOUData.cust?._id) return
    if (!sellTOUData._id) {
      setIsAfterKEPCOContractedPowerManuallyEdited(false)
      lastAppliedRecommendedEssPowerRate.current = null
    }
    findLoadData({
      variables: {
        val: sellTOUData?.cust?._id,
      },
    }).then((result: any) => {
      if (result.data) {
        const sellTOU = Object.values(result.data)[0]
        setLoadData(sellTOU)
      }
    })
    findLoadCustData({
      variables: {
        val: sellTOUData?.cust?._id,
      },
    }).then((result: any) => {
      if (result.data) {
        const data = Object.values(result.data)[0]
        setLoadCustData(data)
      }
    })
  }, [sellTOUData.cust?._id, sellTOUData._id])

  useEffect(() => {
    if (sellTOUData.touVer && sellTOUData.touVer !== '') {
      findKepcoData({
        variables: {
          val: sellTOUData?.touVer,
        },
      }).then((result: any) => {
        if (!result.data) return
        const kepcoTOU = Object.values(result.data)[0] as any
        const nextTouPeriodsData =
          kepcoTOU.kepcoTOUPeriod?.touPeriods || INIT_KEPCO_TOU_PERIODS

        setTouPeriodsData(nextTouPeriodsData)
        setSelectedMonths([1])
        if (LoadCustData?.KEPCOPlanType?.name) {
          setKepcoData(
            //@ts-ignore
            kepcoTOU.data.filter(
              (v: any) => v.name === LoadCustData?.KEPCOPlanType?.name
            )[0]
          )
        }
        //@ts-ignore
        setAllKepcoData(kepcoTOU.data)
      })
    }
  }, [sellTOUData.touVer, LoadCustData?.KEPCOPlanType?.name])

  useEffect(() => {
    if (sellTOUData.holidayYear && sellTOUData.holidayYear !== '') {
      findHolidaysData({
        variables: {
          val: String(sellTOUData.holidayYear),
        },
      }).then((result: any) => {
        //@ts-ignore
        if (result.data) setHolidaysData(Object.values(result.data)[0].data)
      })
    }
  }, [sellTOUData.holidayYear, sellTOUData._id])

  useEffect(() => {
    setSelectedPatternValue(effectiveLoadOpt)
  }, [effectiveLoadOpt])

  useEffect(() => {
    if (!buyTOUList) return
    buyTOUList.map((v) => {
      findPVData({
        variables: {
          val: v?.cust._id,
        },
      }).then((result: any) => {
        console.log('result', result)
        // if (result.data) setPVDataList(Object.values(result.data)[0])
      })
    })
  }, [buyTOUList])

  // SellPlans.tsx

  // ... 기존 코드
  useEffect(() => {
    if (!buyTOUList) return
    const fetchData = async () => {
      const data = await Promise.all(
        buyTOUList.map(async (item) => {
          const custPromise = await findPVData({
            variables: { val: item?.cust?._id },
          })
          const plansPromise = await findOnePurchasePlanData({
            variables: { val: item?._id },
          })

          const [custResult, plansResult] = await Promise.all([
            custPromise,
            plansPromise,
          ])

          return {
            pvdata: custResult.data ? Object.values(custResult.data)[0] : '',
            plansdata: plansResult.data
              ? Object.values(plansResult.data)[0]
              : '',
            // [수정 포인트] 사용자가 선택한 ID를 보존해야 합니다.
            selectedCustId: item?.cust?._id,
            selectedTouId: item?._id,
            annualGeneration: 0,
            generationCost: 0,
          }
        })
      )

      setBuyTOUResults(data)
    }

    fetchData()
  }, [buyTOUList])

  useEffect(() => {
    switch (sellTOUData.networkOpt) {
      case 'kepco':
        setNetworkOptRadioValue('1')
        break

      case 'internal':
        setNetworkOptRadioValue('2')
        break

      case 'ignore':
      default:
        setNetworkOptRadioValue('0')
        break
    }
  }, [sellTOUData.networkOpt])

  // [추가] LoadCustData와 allKepcoData가 모두 준비되면 kepcoData를 확실하게 세팅
  useEffect(() => {
    if (
      LoadCustData?.KEPCOPlanType?.name &&
      allKepcoData &&
      allKepcoData.length > 0
    ) {
      const target = allKepcoData.find(
        (v: any) => v.name === LoadCustData.KEPCOPlanType.name
      )
      if (target) {
        setKepcoData(target)
      }
    }
  }, [LoadCustData, allKepcoData])

  useEffect(() => {
    console.log('buyTOUResults', buyTOUResults)
  }, [buyTOUResults])

  const handleEssPowerRateChange = (essPowerRate: number) => {
    if (isAfterKEPCOContractedPowerManuallyEdited) {
      return
    }

    setSellTOUData((prev) => ({
      ...prev,
      afterKEPCOContractedPower:
        calculateAfterKEPCOContractedPower(essPowerRate),
    }))
  }

  const handleDataChange = (key: string, newValue: number | string) => {
    if (typeof newValue === 'number') {
      if (isNaN(newValue)) {
        setSellTOUData((prev) => {
          const updatedDataUnit = { ...prev, [key]: 0 }
          return updatedDataUnit
        })
      } else {
        setSellTOUData((prev) => {
          const updatedDataUnit = { ...prev, [key]: newValue }
          return updatedDataUnit
        })
      }
    } else {
      setSellTOUData((prev) => {
        const updatedDataUnit = { ...prev, [key]: newValue }
        return updatedDataUnit
      })
    }
  }

  const getRecommendedPowerShareValues = () => {
    const canApplyRecommendation =
      annualLoadDemand > 0 &&
      annualPvGeneration > 0 &&
      Number(LoadCustData?.prevKEPCOContractedPower ?? 0) > 0

    if (!canApplyRecommendation) {
      return {}
    }

    lastAppliedRecommendedEssPowerRate.current = recommendedEssPowerRate
    setIsAfterKEPCOContractedPowerManuallyEdited(false)

    return {
      essPowerRate: recommendedEssPowerRate,
      afterKEPCOContractedPower: recommendedAfterKEPCOContractedPower,
    }
  }

  const handlePlanTypeOpt = (value: string) => {
    switch (value) {
      case '0':
        setSellTOUData((prev) => ({
          ...prev,
          planType: 'peakDeduction',
          rateOpt: 'single',
          sprMinMidRate: 1,
          sumMinMidRate: 1,
          fallMinMidRate: 1,
          winMinMidRate: 1,
          sprMinMaxRate: 1,
          sumMinMaxRate: 1,
          fallMinMaxRate: 1,
          winMinMaxRate: 1,
        }))
        break

      case '2': {
        const recommendedPowerShareValues = getRecommendedPowerShareValues()
        isInitializingExistingSellPlan.current = false
        setSellTOUData((prev) => ({
          ...prev,
          planType: 'flat',
          rateOpt: 'flat',
          ...recommendedPowerShareValues,
          sprMinMidRate: 1,
          sumMinMidRate: 1,
          fallMinMidRate: 1,
          winMinMidRate: 1,
          sprMinMaxRate: 1,
          sumMinMaxRate: 1,
          fallMinMaxRate: 1,
          winMinMaxRate: 1,
        }))
        break
      }

      case '1':
      default: {
        const recommendedPowerShareValues = getRecommendedPowerShareValues()
        isInitializingExistingSellPlan.current = false
        setSellTOUData((prev) => ({
          ...prev,
          planType: 'tou',
          rateOpt:
            prev.rateOpt === 'flat' || prev.planType === 'peakDeduction'
              ? 'kepco'
              : prev.rateOpt,
          ...recommendedPowerShareValues,
        }))
        break
      }
    }
  }

  const handleRateOptRadiobutton = (value: string) => {
    switch (value) {
      case '1':
        setSellTOUData((prev) => {
          return { ...prev, rateOpt: 'single' }
        })
        setTouRate({
          spr: {
            minMid: 1,
            minMax: 1,
          },
          sum: {
            minMid: 1,
            minMax: 1,
          },
          fall: {
            minMid: 1,
            minMax: 1,
          },
          win: {
            minMid: 1,
            minMax: 1,
          },
        })

        break

      case '2':
        setSellTOUData((prev) => {
          return { ...prev, rateOpt: 'userInput' }
        })
        break

      case '0':
      default:
        setSellTOUData((prev) => {
          return { ...prev, rateOpt: 'kepco' }
        })
        setTouRate(kepcoTouRate)
        break
    }
  }

  const handleNetworkOptRadiobutton = (value: string) => {
    switch (value) {
      case '1':
        setSellTOUData((prev) => {
          return { ...prev, networkOpt: 'kepco' }
        })
        break

      case '2':
        setSellTOUData((prev) => {
          return { ...prev, networkOpt: 'internal' }
        })
        break

      case '0':
      default:
        setSellTOUData((prev) => {
          return { ...prev, networkOpt: 'ignore' }
        })
        break
    }
  }

  const toggleMonth = (index: number) => {
    if (selectedMonths.includes(index)) {
      setSelectedMonths(selectedMonths.filter((month) => month !== index))
    } else {
      setSelectedMonths([index])
    }
  }

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    key: string,
    newValue: number
  ) => {
    if (isNaN(newValue)) {
      newValue = 0
    }

    setSellTOUData((prev) => {
      const updatedDataUnit = { ...prev, [key]: newValue }
      return updatedDataUnit
    })
  }

  const handleInputBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    let inputValue = e.target.value

    const floatValue = parseFloat(inputValue)

    if (isNaN(floatValue)) {
      e.target.value = '0'
    } else {
      e.target.value = floatValue.toString()
    }
  }

  const handleProfitShareRateChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    let newValue = parseFloat(e.target.value)

    if (newValue < 0 || isNaN(newValue)) {
      newValue = 0
    }

    if (newValue > 100) {
      newValue = 100
    }

    setSellTOUData((prev) => ({
      ...prev,
      essProfitRate: newValue,
    }))
  }

  const onSave = async () => {
    try {
      if (isCannotCreateSellPlan) {
        alert(
          '전력 구매비용이 기존 한전 요금보다 높아 요금제를 산정할 수 없습니다. 구매요금제 또는 RE100 옵션을 확인하세요.'
        )
        throw new Error('Sell plan cannot be created because min exceeds max')
      }

      const {
        cust,
        holidayYear,
        buyTOUList: buyTOUListObj,
        powerMarketTransactionUnit,
        ...less
      } = sellTOUData
      delete (less as any).loadOpt

      const custId = cust._id
      const holidayYearNum = Number(holidayYear)

      // buyTOUList에서 ID만 추출
      const buyTOUListInput = buyTOUList.map((v) => v?._id)

      if (sellTOUData._id) {
        // [UPDATE]
        await updateSellTOU({
          variables: {
            val: {
              ...less,
              custId: custId,
              holidayYear: holidayYearNum,
              buyTOUIdList: buyTOUListInput,
            },
          },
        })
      } else {
        // [CREATE]
        await createSellTOU({
          variables: {
            val: {
              ...less,
              custId: custId,
              holidayYear: holidayYearNum,
              buyTOUIdList: buyTOUListInput,
            },
          },
        })
      }

      // 데이터 갱신
      refetch()
      handleRefetch()

      // 팝업이 자동으로 "성공" 화면을 띄우므로 별도 처리는 필요 없습니다.
    } catch (e) {
      console.error(e)
      if (
        !(e instanceof Error) ||
        e.message !== 'Sell plan cannot be created because min exceeds max'
      ) {
        alert('저장 중 오류가 발생했습니다.') // 실패 알림
      }

      // [중요] 에러를 던져야 팝업이 로딩을 멈추고 성공 화면을 띄우지 않습니다.
      throw e
    }
  }

  const onDelete = async () => {
    if (sellTOUData._id) {
      await deleteSellTOU({
        variables: {
          val: sellTOUData._id,
        },
      })

      handleRefetch()
      handleResetAll()
      setIsCheck(false)
    }
  }

  const onModify = async () => {
    setIsCheck(false)
    setActiveWorkspaceTab('design')
  }

  const handleResetAll = async () => {
    setActiveWorkspaceTab('design')
    await setSellTOUData(initializeSellPlansData())
    setIsAfterKEPCOContractedPowerManuallyEdited(false)
    lastAppliedRecommendedEssPowerRate.current = null
    isInitializingExistingSellPlan.current = false
    loadedChargeUnitResult.current = undefined
    loadedCalculationKey.current = undefined
    setSellTOUData((prev) => {
      const updatedDataUnit = { ...prev, ...dataUnit }
      return updatedDataUnit
    })
    setUsingLoadData([])
    setSeasonalLoadSum({
      spr: 0,
      sum: 0,
      fall: 0,
      win: 0,
    })
    setPeakLoadSum(EMPTY_SEASONAL_NUM)
    setProfitDelta(EMPTY_SEASONAL_NUM)

    setSelectedMonths([])
    setLoadData(undefined)
    setKepcoData(undefined)
    setHolidaysData(undefined)
    setBuyTOUList([])
    setBuyCost({
      spr: { pv: 0, charge: 0 },
      sum: { pv: 0, charge: 0 },
      fall: { pv: 0, charge: 0 },
      win: { pv: 0, charge: 0 },
    })
    setBuyCostList([])
    setPlanDiagnostic(null)
    setSelectedMonths([1])
    setLoadGraph([])
  }

  return (
    <>
      <PageWrapper>
        <SearchListWrapper>
          <SearchList
            title="요금제 목록"
            onReset={handleResetAll}
            findOne={handleFindOne}
            setIsCheck={setIsCheck}
            findAllListgql={findAllSellTOUGQL}
            setRefetch={setListRefetch}
            nameKey="name"
            descriptionRenderer={(item: any) => {
              const customer = LoadCusList?.find(
                (cust: any) => cust._id === item.custId
              )
              return customer?.name || '고객 미지정'
            }}
          />
        </SearchListWrapper>
        {isCheck ? (
          <ContentWrapper>
            <Header>
              <TitleButton
                title={`${sellTOUData.cust?.name} - ${sellTOUData.name} `}
                onDeleteClick={onDelete}
                onModify={onModify}
                isModify={isModify}
                isCheck={isCheck}
              />
            </Header>
            <BodyWrapper>
              <Body>
                <Left>
                  <DetailFrame>
                    <LabelOnly
                      label={
                        sellTOUData.planType === 'flat'
                          ? '요금제 단가'
                          : '시간대 그래프'
                      }
                    />
                    <DetailColWrapper>
                      {sellTOUData.planType === 'flat' ? null : (
                        <GraphWrapper width="100%">
                          <GraphBody>
                            <TOUHeatMap
                              width="100%"
                              height="130px"
                              title="봄"
                              data={touPeriodsData?.spr}
                            />
                            <TOUHeatMap
                              width="100%"
                              height="130px"
                              title="여름"
                              data={touPeriodsData?.sum}
                            />
                            <TOUHeatMap
                              width="100%"
                              height="130px"
                              title="가을"
                              data={touPeriodsData?.fall}
                            />
                            <TOUHeatMap
                              width="100%"
                              height="130px"
                              title="겨울"
                              data={touPeriodsData?.win}
                              showLegend
                            />
                          </GraphBody>
                        </GraphWrapper>
                      )}
                      <Table>
                        <TableRow>
                          <TableCell
                            style={{ borderTopLeftRadius: '4px' }}
                          ></TableCell>
                          <TableCell>봄</TableCell>
                          <TableCell>여름</TableCell>
                          <TableCell>가을</TableCell>
                          <TableCell style={{ borderTopRightRadius: '4px' }}>
                            겨울
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>경부하</TableCell>
                          <TableCell white>
                            {formatChargeUnitResult(
                              sellTOUData.chargeUnitResult.spr.min
                            )}
                          </TableCell>
                          <TableCell white>
                            {formatChargeUnitResult(
                              sellTOUData.chargeUnitResult.sum.min
                            )}
                          </TableCell>
                          <TableCell white>
                            {formatChargeUnitResult(
                              sellTOUData.chargeUnitResult.fall.min
                            )}
                          </TableCell>
                          <TableCell white>
                            {formatChargeUnitResult(
                              sellTOUData.chargeUnitResult.win.min
                            )}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>중간부하</TableCell>
                          <TableCell white>
                            {formatChargeUnitResult(
                              sellTOUData.chargeUnitResult.spr.mid
                            )}
                          </TableCell>
                          <TableCell white>
                            {formatChargeUnitResult(
                              sellTOUData.chargeUnitResult.sum.mid
                            )}
                          </TableCell>
                          <TableCell white>
                            {formatChargeUnitResult(
                              sellTOUData.chargeUnitResult.fall.mid
                            )}
                          </TableCell>
                          <TableCell white>
                            {formatChargeUnitResult(
                              sellTOUData.chargeUnitResult.win.mid
                            )}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell style={{ borderBottomLeftRadius: '4px' }}>
                            최대부하
                          </TableCell>
                          <TableCell white>
                            {formatChargeUnitResult(
                              sellTOUData.chargeUnitResult.spr.max
                            )}
                          </TableCell>
                          <TableCell white>
                            {formatChargeUnitResult(
                              sellTOUData.chargeUnitResult.sum.max
                            )}
                          </TableCell>
                          <TableCell white>
                            {formatChargeUnitResult(
                              sellTOUData.chargeUnitResult.fall.max
                            )}
                          </TableCell>
                          <TableCell
                            white
                            style={{ borderBottomRightRadius: '4px' }}
                          >
                            {formatChargeUnitResult(
                              sellTOUData.chargeUnitResult.win.max
                            )}
                          </TableCell>
                        </TableRow>
                      </Table>
                    </DetailColWrapper>
                  </DetailFrame>
                  {/* <OptionFrame>
                  <LabelOnly label="선택한 옵션 목록" />
                  <OptionListWrapper>
                    <OptionDetailWrapper>
                      <OptionDetailBox>
                        <Rectangle />
                        <OptionTextBox>한전 요금제 : </OptionTextBox>
                        <OptionTextBox>{sellTOUData.touVer}</OptionTextBox>
                      </OptionDetailBox>
                      <OptionDetailBox>
                        <Rectangle />
                        <OptionTextBox>공휴일 정보 : </OptionTextBox>
                        <OptionTextBox>{sellTOUData.holidayYear}</OptionTextBox>
                      </OptionDetailBox>
                    </OptionDetailWrapper>
              
                    <OptionDetailWrapper>
                      <OptionDetailBox>
                        <Rectangle />
                        <OptionTextBox>고객 전력 구매 비율 : </OptionTextBox>
                        <OptionTextBox>
                          {100 - sellTOUData.essPowerRate} %
                        </OptionTextBox>
                      </OptionDetailBox>
                      <OptionDetailBox>
                        <Rectangle />
                        <OptionTextBox>
                          변경될 한전과의 계약 전력 :
                        </OptionTextBox>
                        <OptionTextBox>
                          {sellTOUData.afterKEPCOContractedPower} kW
                        </OptionTextBox>
                      </OptionDetailBox>
                      <OptionDetailBox>
                        <Rectangle />
                        <OptionTextBox>ESS 사업자 이익 비율 : </OptionTextBox>
                        <OptionTextBox>
                          {sellTOUData.essProfitRate} %
                        </OptionTextBox>
                      </OptionDetailBox>
                      <OptionDetailBox>
                        <Rectangle />
                        <OptionTextBox>비용 옵션 : </OptionTextBox>
                        <OptionTextBox>{sellTOUData.networkOpt}</OptionTextBox>
                      </OptionDetailBox>
                    </OptionDetailWrapper>
                  </OptionListWrapper>
                </OptionFrame> */}
                </Left>

                <Right>
                  {/* 수정예정 */}
                  {/* <DetailFrame>
                  <LabelOnly label="PV 구입비용 및 단가" />
                  <DetailColWrapper>
                    <Table>
                      <TableTitleFrame>
                        <CustomerNameWrapper>
                          <CustomerName>홍길동 고객</CustomerName>
                        </CustomerNameWrapper>
                        <PlanName>요금제 이름</PlanName>
                      </TableTitleFrame>
                      <TableRow>
                        <TableCell2></TableCell2>
                        <TableCell2>봄</TableCell2>
                        <TableCell2>여름</TableCell2>
                        <TableCell2>가을</TableCell2>
                        <TableCell2>겨울</TableCell2>
                        <TableCell2 style={{ borderTopRightRadius: '4px' }}>
                          총
                        </TableCell2>
                      </TableRow>
                      <TableRow>
                        <TableCell2>발전량</TableCell2>
                        <TableCell2 white>0</TableCell2>
                        <TableCell2 white>0</TableCell2>
                        <TableCell2 white>0</TableCell2>
                        <TableCell2 white>0</TableCell2>
                        <TableCell2 white>0</TableCell2>
                      </TableRow>
                      <TableRow>
                        <TableCell2>PV 구입비용</TableCell2>
                        <TableCell2 white>0</TableCell2>
                        <TableCell2 white>0</TableCell2>
                        <TableCell2 white>0</TableCell2>
                        <TableCell2 white>0</TableCell2>
                        <TableCell2 white>0</TableCell2>
                      </TableRow>
                      <TableRow>
                        <TableCell2 style={{ borderBottomLeftRadius: '4px' }}>
                          <SubText>
                            PV 단가 {'\n'}
                            <SubTextUnit> (원/kWh)</SubTextUnit>
                          </SubText>
                        </TableCell2>
                        <TableCell2 white>0</TableCell2>
                        <TableCell2 white>0</TableCell2>
                        <TableCell2 white>0</TableCell2>
                        <TableCell2 white>0</TableCell2>
                        <TableCell2
                          white
                          style={{ borderBottomRightRadius: '4px' }}
                        >
                          0
                        </TableCell2>
                      </TableRow>
                    </Table>
                  </DetailColWrapper>
                </DetailFrame> */}
                  <OptionFrame>
                    <LabelOnly label="선택한 옵션 목록" />
                    <OptionListWrapper>
                      <OptionDetailWrapper>
                        <OptionDetailBox>
                          <Rectangle />
                          <OptionTextBox>한전 요금제 : </OptionTextBox>
                          <OptionTextBox>{sellTOUData.touVer}</OptionTextBox>
                        </OptionDetailBox>
                        <OptionDetailBox>
                          <Rectangle />
                          <OptionTextBox>공휴일 정보 : </OptionTextBox>
                          <OptionTextBox>
                            {sellTOUData.holidayYear}
                          </OptionTextBox>
                        </OptionDetailBox>
                      </OptionDetailWrapper>
                      {/* 구분선*/}
                      <OptionDetailWrapper>
                        <OptionDetailBox>
                          <Rectangle />
                          <OptionTextBox>요금제 산정 방식 : </OptionTextBox>
                          <OptionTextBox>
                            {sellTOUData.planType === 'flat'
                              ? '모든 시간대 비율 차감형 단일단가'
                              : isPeakDeductionSellPlan
                                ? '최대부하 시간대 차감형 단일단가'
                                : '모든 시간대 비율 차감형 TOU'}
                          </OptionTextBox>
                        </OptionDetailBox>
                        <OptionDetailBox>
                          <Rectangle />
                          <OptionTextBox>가격비율 : </OptionTextBox>
                          <OptionTextBox>
                            {sellTOUData.planType === 'flat'
                              ? '모든 계절 단일 단가'
                              : isPeakDeductionSellPlan
                                ? '최대부하 시간대 단일 단가'
                                : sellTOUData.rateOpt === 'single'
                                  ? '단일 단가'
                                  : sellTOUData.rateOpt === 'userInput'
                                    ? '직접 입력'
                                    : '한전 TOU 요금제'}
                          </OptionTextBox>
                        </OptionDetailBox>
                      </OptionDetailWrapper>
                      {/* 구분선*/}
                      <OptionDetailWrapper>
                        {isPeakDeductionSellPlan ? (
                          <OptionDetailBox>
                            <Rectangle />
                            <OptionTextBox>차감 기준 : </OptionTextBox>
                            <OptionTextBox>
                              최대부하 시간대 소비량에서 PV 총 발전량만큼 차감
                            </OptionTextBox>
                          </OptionDetailBox>
                        ) : (
                          <>
                            <OptionDetailBox>
                              <Rectangle />
                              <OptionTextBox>
                                고객 전력 구매 비율 :{' '}
                              </OptionTextBox>
                              <OptionTextBox>
                                {100 - sellTOUData.essPowerRate} %
                              </OptionTextBox>
                            </OptionDetailBox>
                            <OptionDetailBox>
                              <Rectangle />
                              <OptionTextBox>
                                변경될 한전과의 계약 전력 :
                              </OptionTextBox>
                              <OptionTextBox>
                                {sellTOUData.afterKEPCOContractedPower} kW
                              </OptionTextBox>
                            </OptionDetailBox>
                          </>
                        )}
                        <OptionDetailBox>
                          <Rectangle />
                          <OptionTextBox>RE100 필요 여부 : </OptionTextBox>
                          <OptionTextBox>
                            {re100Opt === 'achieve' ? '필요' : '해당 없음'}
                          </OptionTextBox>
                        </OptionDetailBox>
                        <OptionDetailBox>
                          <Rectangle />
                          <OptionTextBox>녹색 프리미엄 단가 : </OptionTextBox>
                          <OptionTextBox>
                            {Number(greenPremiumUnit).toLocaleString()} 원
                          </OptionTextBox>
                        </OptionDetailBox>
                        {isCannotCreateSellPlan ? (
                          <OptionDetailBox>
                            <Rectangle />
                            <OptionTextBox>요금제 산정 : </OptionTextBox>
                            <OptionTextBox>불가</OptionTextBox>
                          </OptionDetailBox>
                        ) : (
                          <OptionDetailBox>
                            <Rectangle />
                            <OptionTextBox>
                              ESS 사업자 이익 비율 :{' '}
                            </OptionTextBox>
                            <OptionTextBox>
                              {sellTOUData.essProfitRate} %
                            </OptionTextBox>
                          </OptionDetailBox>
                        )}
                        <OptionDetailBox>
                          <Rectangle />
                          <OptionTextBox>비용 옵션 : </OptionTextBox>
                          <OptionTextBox>
                            {sellTOUData.networkOpt}
                          </OptionTextBox>
                        </OptionDetailBox>
                      </OptionDetailWrapper>
                    </OptionListWrapper>
                  </OptionFrame>
                </Right>
              </Body>
            </BodyWrapper>
          </ContentWrapper>
        ) : (
          <ContentWrapper $tabsAttached>
            <Header>
              <SellPlanWorkspaceHeader
                activeTab={activeWorkspaceTab}
                onTabChange={handleWorkspaceTabChange}
                title="전력 판매 요금제 설계"
                onSaveClick={onSave}
                onCancelClick={handleResetAll}
                onDeleteClick={onDelete}
                isModify={isModify}
              />
              {activeWorkspaceTab === 'design' ? (
                <PowerSellBoard
                  name={sellTOUData.cust?.name}
                  ratePlan={sellTOUData.name}
                  chartUnitResult={displayChargeUnitResult}
                  beforeIncome={beforeSeasonCharge}
                  afterIncome={displayAfterSeasonCharge}
                  re100Opt={re100Opt}
                  essBusinessProfit={sumSeasonalNum(
                    diagnosticProfitShareCharge
                  )}
                  essProfitRate={sellTOUData.essProfitRate}
                />
              ) : null}
            </Header>
            <BodyWrapper ref={workspaceBodyRef}>
              {activeWorkspaceTab === 'design' ? (
                <Body>
                  <Left>
                    <SectionFrame>
                      <SectionHeader>
                        <SectionMark />
                        <SectionTitle>수용가 기준 설정</SectionTitle>
                        <SectionDivider />
                      </SectionHeader>
                      <LabelInput
                        label="요금제명"
                        placeholder="이름을 입력하세요"
                        onChange={(e) =>
                          handleDataChange('name', e.target.value)
                        }
                        value={sellTOUData.name}
                      />
                      <DetailFrame>
                        <LabelAutoComplete
                          label="수용가"
                          options={LoadCusList}
                          value={sellTOUData.cust}
                          setData={setSellTOUData}
                          fieldName="cust"
                        />
                      </DetailFrame>
                      <DetailFrame>
                        <LabelOnly label="수용가 소비 패턴 확인" />
                        <DetailDescriptionText>
                          수용가 정보 화면에 저장된 소비 패턴 설정을 사용합니다.
                        </DetailDescriptionText>
                        <DetailColWrapper>
                          <DetailWrapper $direction="column">
                            <GraphWrapper height="auto" width="100%">
                              <MonthChipWrapper>
                                {Array.from({ length: 12 }, (_, index) => (
                                  <MonthChip
                                    key={index + 1}
                                    selected={selectedMonths.includes(
                                      index + 1
                                    )}
                                    onClick={() => toggleMonth(index + 1)}
                                  >
                                    <MonthChipText>{`${index + 1}월`}</MonthChipText>
                                  </MonthChip>
                                ))}
                              </MonthChipWrapper>
                              <GraphBody>
                                <PowerSourceStackedAreaChart
                                  month={selectedMonths[0]}
                                  originalData={loadGraph ? loadGraph : []}
                                  essData={ESSLoadData}
                                  kepcoData={kepcoLoadData}
                                  width="100%"
                                  height="300px"
                                  selectedChartDataType={selectedPatternValue}
                                />
                              </GraphBody>
                              <TextWrapper $align="center">
                                <Text>연간 수요량</Text>
                                <TextBox>
                                  <Text fontColor="#57C9A7" fontSize="20px">
                                    총
                                  </Text>
                                  <TextBox2>
                                    <Text
                                      fontColor="#57C9A7"
                                      fontSize="22px"
                                      fontWeight="600"
                                    >
                                      {Number(
                                        (
                                          seasonalLoadSum.spr +
                                          seasonalLoadSum.sum +
                                          seasonalLoadSum.fall +
                                          seasonalLoadSum.win
                                        ).toFixed(0)
                                      ).toLocaleString()}
                                    </Text>
                                    <Text fontColor="#57C9A7" fontSize="18px">
                                      kWh
                                    </Text>
                                  </TextBox2>
                                </TextBox>
                              </TextWrapper>
                              <SeasonFrame>
                                <SeasonBox>
                                  <Text fontColor="#666" fontWeight="500">
                                    봄
                                  </Text>
                                  <SeasonTextBox>
                                    <Text
                                      fontColor="#4D4D4D"
                                      fontSize="14px"
                                      fontWeight="600"
                                    >
                                      {Number(
                                        seasonalLoadSum.spr
                                          .toFixed(0)
                                          .toLocaleString()
                                      ).toLocaleString()}
                                    </Text>
                                    <Text fontColor="#666" fontWeight="500">
                                      kWh
                                    </Text>
                                  </SeasonTextBox>
                                </SeasonBox>
                                <SeasonBox>
                                  <Text fontColor="#666" fontWeight="500">
                                    여름
                                  </Text>
                                  <SeasonTextBox>
                                    <Text
                                      fontColor="#4D4D4D"
                                      fontSize="14px"
                                      fontWeight="600"
                                    >
                                      {Number(
                                        seasonalLoadSum.sum.toFixed(0)
                                      ).toLocaleString()}
                                    </Text>
                                    <Text fontColor="#666" fontWeight="500">
                                      kWh
                                    </Text>
                                  </SeasonTextBox>
                                </SeasonBox>
                                <SeasonBox>
                                  <Text fontColor="#666" fontWeight="500">
                                    가을
                                  </Text>
                                  <SeasonTextBox>
                                    <Text
                                      fontColor="#4D4D4D"
                                      fontSize="14px"
                                      fontWeight="600"
                                    >
                                      {Number(
                                        seasonalLoadSum.fall.toFixed(0)
                                      ).toLocaleString()}
                                    </Text>
                                    <Text fontColor="#666" fontWeight="500">
                                      kWh
                                    </Text>
                                  </SeasonTextBox>
                                </SeasonBox>
                                <SeasonBox>
                                  <Text fontColor="#666" fontWeight="500">
                                    겨울
                                  </Text>
                                  <SeasonTextBox>
                                    <Text
                                      fontColor="#4D4D4D"
                                      fontSize="14px"
                                      fontWeight="600"
                                    >
                                      {Number(
                                        seasonalLoadSum.win.toFixed(0)
                                      ).toLocaleString()}
                                    </Text>
                                    <Text fontColor="#666" fontWeight="500">
                                      kWh
                                    </Text>
                                  </SeasonTextBox>
                                </SeasonBox>
                              </SeasonFrame>
                            </GraphWrapper>
                          </DetailWrapper>
                        </DetailColWrapper>
                      </DetailFrame>
                    </SectionFrame>
                    <SectionFrame>
                      <SectionHeader>
                        <SectionMark />
                        <SectionTitle>설계 조건</SectionTitle>
                        <SectionDivider />
                      </SectionHeader>
                      <DetailFrame>
                        <DetailColWrapper>
                          <PlanDefaultSummaryBox>
                            <PlanDefaultSummaryItem>
                              <PlanDefaultSummaryLabel>
                                한전 요금제
                              </PlanDefaultSummaryLabel>
                              <PlanDefaultSummaryValue>
                                {formatDefaultValue(sellTOUData.touVer)}
                              </PlanDefaultSummaryValue>
                            </PlanDefaultSummaryItem>
                            <PlanDefaultSummaryItem>
                              <PlanDefaultSummaryLabel>
                                공휴일
                              </PlanDefaultSummaryLabel>
                              <PlanDefaultSummaryValue>
                                {formatDefaultValue(sellTOUData.holidayYear)}
                              </PlanDefaultSummaryValue>
                            </PlanDefaultSummaryItem>
                            <PlanDefaultSummaryItem>
                              <PlanDefaultSummaryLabel>
                                기후환경요금 단가
                              </PlanDefaultSummaryLabel>
                              <PlanDefaultSummaryValue>
                                {formatDefaultValue(
                                  sellTOUData.environmentalUnit,
                                  ' 원/kWh'
                                )}
                              </PlanDefaultSummaryValue>
                            </PlanDefaultSummaryItem>
                            <PlanDefaultSummaryItem>
                              <PlanDefaultSummaryLabel>
                                녹색 프리미엄 단가
                              </PlanDefaultSummaryLabel>
                              <PlanDefaultSummaryValue>
                                {formatDefaultValue(
                                  sellTOUData.greenPremiumUnit ?? 0,
                                  ' 원/kWh'
                                )}
                              </PlanDefaultSummaryValue>
                            </PlanDefaultSummaryItem>
                          </PlanDefaultSummaryBox>
                        </DetailColWrapper>
                      </DetailFrame>
                    </SectionFrame>
                    <SectionFrame>
                      <SectionHeader>
                        <SectionMark />
                        <SectionTitle>전력 구매 비용 산정</SectionTitle>
                        <SectionDivider />
                      </SectionHeader>
                      <DetailFrame style={{ width: '100%' }}>
                        {/* 총 구매 비용 */}
                        <TotalPurchaseValue
                          buyCost={buyCost}
                          buyCostList={buyCostList}
                          buyTOUList={buyTOUList}
                          setBuyTOUList={setBuyTOUList}
                          showRecExcludedWarning={
                            showRecExcludedPurchaseWarning
                          }
                          showRecIncludedWarning={
                            showRecIncludedPurchaseWarning
                          }
                        >
                          {sellPlanFeasibilitySummary}
                        </TotalPurchaseValue>
                      </DetailFrame>
                    </SectionFrame>
                  </Left>
                  <Right>
                    <SectionFrame>
                      <SectionHeader>
                        <SectionMark />
                        <SectionTitle>판매요금제 산정 방식</SectionTitle>
                        <SectionDivider />
                      </SectionHeader>
                      <DetailFrame>
                        <LabelOnly label="요금제 산정 방식" />
                        <DetailColWrapper>
                          <DetailWrapper>
                            <ColumnRadioButton
                              list={[
                                {
                                  label: '최대부하 시간대 차감형 단일단가',
                                },
                                {
                                  label: '모든 시간대 비율 차감형 TOU',
                                },
                                {
                                  label: '모든 시간대 비율 차감형 단일단가',
                                },
                              ]}
                              onChange={handlePlanTypeOpt}
                              value={planTypeRadioValue}
                            />
                          </DetailWrapper>
                          {isCannotCreateSellPlan ? (
                            <Text
                              fontColor="#d32f2f"
                              fontSize="13px"
                              fontWeight="600"
                            >
                              요금제 산정 불가
                            </Text>
                          ) : null}
                        </DetailColWrapper>
                      </DetailFrame>

                      {isPeakDeductionSellPlan ? null : (
                        <>
                          <DetailFrame>
                            <TextWrapper>
                              <LabelOnly label="ESS-한전 전력 분담 비율" />
                              <Text fontSize="12px" fontColor="#808080">
                                권장 : {recommendedPowerPurchaseRateText}%
                              </Text>
                            </TextWrapper>
                            <DetailWrapper>
                              <Ratio
                                player1="ESS 사업자"
                                player2="한전"
                                value={sellTOUData.essPowerRate}
                                setData={setSellTOUData}
                                keyName="essPowerRate"
                                onValueChange={handleEssPowerRateChange}
                              />
                            </DetailWrapper>
                          </DetailFrame>
                          <DetailFrame gap="4px">
                            <LabelInput
                              label="변경될 한전과의 계약전력"
                              placeholder="kW"
                              value={sellTOUData.afterKEPCOContractedPower.toString()}
                              onChange={(e) => {
                                setIsAfterKEPCOContractedPowerManuallyEdited(
                                  true
                                )
                                handleDataChange(
                                  'afterKEPCOContractedPower',
                                  Number(e.target.value)
                                )
                              }}
                              type="number"
                              unit="kW"
                            />
                            <DetailColWrapper>
                              <TextBox2>
                                <Text fontColor="#4d4d4d" fontWeight="500">
                                  기존 계약 전력{' '}
                                  {LoadCustData
                                    ? Number(
                                        LoadCustData.prevKEPCOContractedPower
                                      ).toLocaleString()
                                    : 0}
                                  kW
                                </Text>
                              </TextBox2>
                            </DetailColWrapper>
                          </DetailFrame>
                          <DetailFrame>
                            <LabelUnit
                              label="연간 기후환경요금 및 기본요금 절감액"
                              unit="단위: 원"
                            />
                            <DetailColWrapper>
                              <Table>
                                <TableRow>
                                  <TableCell
                                    style={{ borderTopLeftRadius: '4px' }}
                                  ></TableCell>
                                  <TableCell>봄</TableCell>
                                  <TableCell>여름</TableCell>
                                  <TableCell>가을</TableCell>
                                  <TableCell
                                    style={{ borderTopRightRadius: '4px' }}
                                  >
                                    겨울
                                  </TableCell>
                                </TableRow>
                                <TableRow>
                                  <TableCell>기후 환경 요금</TableCell>
                                  <TableCell white>
                                    {Number(
                                      expectReduceCharge.spr.envCharge
                                    ).toLocaleString()}
                                  </TableCell>
                                  <TableCell white>
                                    {Number(
                                      expectReduceCharge.sum.envCharge
                                    ).toLocaleString()}
                                  </TableCell>
                                  <TableCell white>
                                    {Number(
                                      expectReduceCharge.fall.envCharge
                                    ).toLocaleString()}
                                  </TableCell>
                                  <TableCell white>
                                    {Number(
                                      expectReduceCharge.win.envCharge
                                    ).toLocaleString()}
                                  </TableCell>
                                </TableRow>
                                <TableRow>
                                  <TableCell>기본 요금</TableCell>
                                  <TableCell white>
                                    {Number(
                                      expectReduceCharge.spr.defaultCharge
                                    ).toLocaleString()}
                                  </TableCell>
                                  <TableCell white>
                                    {Number(
                                      expectReduceCharge.sum.defaultCharge
                                    ).toLocaleString()}
                                  </TableCell>
                                  <TableCell white>
                                    {Number(
                                      expectReduceCharge.fall.defaultCharge
                                    ).toLocaleString()}
                                  </TableCell>
                                  <TableCell white>
                                    {Number(
                                      expectReduceCharge.win.defaultCharge
                                    ).toLocaleString()}
                                  </TableCell>
                                </TableRow>
                                <TableRow>
                                  <TableCell
                                    style={{ borderBottomLeftRadius: '4px' }}
                                  >
                                    총
                                  </TableCell>
                                  <TableCell white>
                                    {Number(
                                      expectReduceCharge.spr.envCharge +
                                        expectReduceCharge.spr.defaultCharge
                                    ).toLocaleString()}
                                  </TableCell>
                                  <TableCell white>
                                    {Number(
                                      expectReduceCharge.sum.envCharge +
                                        expectReduceCharge.sum.defaultCharge
                                    ).toLocaleString()}
                                  </TableCell>
                                  <TableCell white>
                                    {Number(
                                      expectReduceCharge.fall.envCharge +
                                        expectReduceCharge.fall.defaultCharge
                                    ).toLocaleString()}
                                  </TableCell>
                                  <TableCell
                                    white
                                    style={{ borderBottomRightRadius: '4px' }}
                                  >
                                    {Number(
                                      expectReduceCharge.win.envCharge +
                                        expectReduceCharge.win.defaultCharge
                                    ).toLocaleString()}
                                  </TableCell>
                                </TableRow>
                              </Table>
                            </DetailColWrapper>
                          </DetailFrame>
                        </>
                      )}
                    </SectionFrame>
                    {sellTOUData.planType === 'tou' ? (
                      <SectionFrame>
                        <SectionHeader>
                          <SectionMark />
                          <CollapsibleSectionTitle
                            type="button"
                            aria-expanded={!isTouRateSectionCollapsed}
                            onClick={() =>
                              setIsTouRateSectionCollapsed((prev) => !prev)
                            }
                          >
                            TOU 시간대 및 단가 비율 설정
                            <SectionTitleToggleText>
                              {isTouRateSectionCollapsed ? '열기' : '접기'}
                            </SectionTitleToggleText>
                            <SectionTitleChevron
                              $collapsed={isTouRateSectionCollapsed}
                            />
                          </CollapsibleSectionTitle>
                          <SectionDivider />
                        </SectionHeader>
                        {!isTouRateSectionCollapsed ? (
                          <>
                            <DetailFrame>
                              <LabelOnly label="한전 TOU 시간대" />
                              <DetailColWrapper>
                                <DetailWrapper>
                                  <GraphWrapper height="100%">
                                    <GraphBody>
                                      <TOUHeatMap
                                        width="100%"
                                        height="130px"
                                        title="봄"
                                        data={touPeriodsData?.spr}
                                      />
                                      <TOUHeatMap
                                        width="100%"
                                        height="130px"
                                        title="여름"
                                        data={touPeriodsData?.sum}
                                      />
                                      <TOUHeatMap
                                        width="100%"
                                        height="130px"
                                        title="가을"
                                        data={touPeriodsData?.fall}
                                      />
                                      <TOUHeatMap
                                        width="100%"
                                        height="130px"
                                        title="겨울"
                                        data={touPeriodsData?.win}
                                        showLegend
                                      />
                                    </GraphBody>
                                  </GraphWrapper>
                                </DetailWrapper>
                              </DetailColWrapper>
                            </DetailFrame>
                            <DetailFrame>
                              <LabelOnly label="TOU 시간대별 단가 비율 설정" />
                              <DetailColWrapper>
                                <DetailWrapper>
                                  <div style={{ width: '65%' }}>
                                    <ColumnRadioCostRatio
                                      list={[
                                        {
                                          label: '한전 TOU 요금제로 산정',
                                        },
                                        {
                                          label: '단일 단가 사용',
                                        },
                                        {
                                          label: '직접 입력',
                                        },
                                      ]}
                                      onChange={(value: string) =>
                                        handleRateOptRadiobutton(value)
                                      }
                                      value={rateOptRadioValue}
                                    />
                                  </div>
                                  {rateOptRadioValue === '2' ? (
                                    <Table>
                                      <TableRow>
                                        <TableCell2
                                          style={{ borderTopLeftRadius: '4px' }}
                                        ></TableCell2>
                                        <TableCell2>봄</TableCell2>
                                        <TableCell2>여름</TableCell2>
                                        <TableCell2>가을</TableCell2>
                                        <TableCell2
                                          style={{
                                            borderTopRightRadius: '4px',
                                          }}
                                        >
                                          겨울
                                        </TableCell2>
                                      </TableRow>
                                      <TableRow>
                                        <TableCell2>최저/중간</TableCell2>
                                        <TableCell2 white>
                                          <Input
                                            defaultValue="0"
                                            onBlur={handleInputBlur}
                                            onChange={(e: any) =>
                                              handleInputChange(
                                                e,
                                                'sprMinMidRate',
                                                e.target.value
                                              )
                                            }
                                            value={sellTOUData.sprMinMidRate?.toString()}
                                            type="text"
                                          />
                                        </TableCell2>
                                        <TableCell2 white>
                                          <Input
                                            defaultValue="0"
                                            onBlur={handleInputBlur}
                                            onChange={(e: any) =>
                                              handleInputChange(
                                                e,
                                                'sumMinMidRate',
                                                e.target.value
                                              )
                                            }
                                            value={sellTOUData.sumMinMidRate?.toString()}
                                            type="text"
                                          />
                                        </TableCell2>
                                        <TableCell2 white>
                                          <Input
                                            defaultValue="0"
                                            onBlur={handleInputBlur}
                                            onChange={(e: any) =>
                                              handleInputChange(
                                                e,
                                                'fallMinMidRate',
                                                e.target.value
                                              )
                                            }
                                            value={sellTOUData.fallMinMidRate?.toString()}
                                            type="text"
                                          />
                                        </TableCell2>
                                        <TableCell2 white>
                                          <Input
                                            defaultValue="0"
                                            onBlur={handleInputBlur}
                                            onChange={(e: any) =>
                                              handleInputChange(
                                                e,
                                                'winMinMidRate',
                                                e.target.value
                                              )
                                            }
                                            value={sellTOUData.winMinMidRate?.toString()}
                                            type="text"
                                          />
                                        </TableCell2>
                                      </TableRow>
                                      <TableRow>
                                        <TableCell2
                                          style={{
                                            borderBottomLeftRadius: '4px',
                                          }}
                                        >
                                          최저/최대
                                        </TableCell2>
                                        <TableCell2 white>
                                          <Input
                                            defaultValue="0"
                                            onBlur={handleInputBlur}
                                            onChange={(e: any) =>
                                              handleInputChange(
                                                e,
                                                'sprMinMaxRate',
                                                e.target.value
                                              )
                                            }
                                            value={sellTOUData.sprMinMaxRate?.toString()}
                                            type="text"
                                          />
                                        </TableCell2>
                                        <TableCell2 white>
                                          <Input
                                            defaultValue="0"
                                            onBlur={handleInputBlur}
                                            onChange={(e: any) =>
                                              handleInputChange(
                                                e,
                                                'sumMinMaxRate',
                                                e.target.value
                                              )
                                            }
                                            value={sellTOUData.sumMinMaxRate?.toString()}
                                            type="text"
                                          />
                                        </TableCell2>
                                        <TableCell2 white>
                                          <Input
                                            defaultValue="0"
                                            onBlur={handleInputBlur}
                                            onChange={(e: any) =>
                                              handleInputChange(
                                                e,
                                                'fallMinMaxRate',
                                                e.target.value
                                              )
                                            }
                                            value={sellTOUData.fallMinMaxRate?.toString()}
                                            type="text"
                                          />
                                        </TableCell2>
                                        <TableCell2
                                          white
                                          style={{
                                            borderBottomRightRadius: '4px',
                                          }}
                                        >
                                          <Input
                                            defaultValue="0"
                                            onBlur={handleInputBlur}
                                            onChange={(e: any) =>
                                              handleInputChange(
                                                e,
                                                'winMinMaxRate',
                                                e.target.value
                                              )
                                            }
                                            value={sellTOUData.winMinMaxRate?.toString()}
                                            type="text"
                                          />
                                        </TableCell2>
                                      </TableRow>
                                    </Table>
                                  ) : (
                                    <Table>
                                      <TableRow>
                                        <TableCell2
                                          style={{ borderTopLeftRadius: '4px' }}
                                        ></TableCell2>
                                        <TableCell2>봄</TableCell2>
                                        <TableCell2>여름</TableCell2>
                                        <TableCell2>가을</TableCell2>
                                        <TableCell2
                                          style={{
                                            borderTopRightRadius: '4px',
                                          }}
                                        >
                                          겨울
                                        </TableCell2>
                                      </TableRow>
                                      <TableRow>
                                        <TableCell2>최저/중간</TableCell2>
                                        <TableCell2 white>
                                          {sellTOUData.sprMinMidRate || 0}
                                        </TableCell2>
                                        <TableCell2 white>
                                          {sellTOUData.sumMinMidRate || 0}
                                        </TableCell2>
                                        <TableCell2 white>
                                          {sellTOUData.fallMinMidRate || 0}
                                        </TableCell2>
                                        <TableCell2 white>
                                          {sellTOUData.winMinMidRate || 0}
                                        </TableCell2>
                                      </TableRow>
                                      <TableRow>
                                        <TableCell2
                                          style={{
                                            borderBottomLeftRadius: '4px',
                                          }}
                                        >
                                          최저/최대
                                        </TableCell2>
                                        <TableCell2 white>
                                          {sellTOUData.sprMinMaxRate || 0}
                                        </TableCell2>
                                        <TableCell2 white>
                                          {sellTOUData.sumMinMaxRate || 0}
                                        </TableCell2>
                                        <TableCell2 white>
                                          {sellTOUData.fallMinMaxRate || 0}
                                        </TableCell2>
                                        <TableCell2
                                          white
                                          style={{
                                            borderBottomRightRadius: '4px',
                                          }}
                                        >
                                          {sellTOUData.winMinMaxRate || 0}
                                        </TableCell2>
                                      </TableRow>
                                    </Table>
                                  )}
                                </DetailWrapper>
                              </DetailColWrapper>
                            </DetailFrame>
                          </>
                        ) : null}
                      </SectionFrame>
                    ) : null}
                    <SectionFrame>
                      <SectionHeader>
                        <SectionMark />
                        <SectionTitle>ESS 사업자 이익 설정</SectionTitle>
                        <SectionDivider />
                      </SectionHeader>
                      <DetailFrame>
                        <LabelOnly label="요금 설계 이익 중 ESS 사업자 이익 비율" />
                        <DetailWrapper $direction="column">
                          <ProfitShareSummaryGrid>
                            <ProfitShareSummaryCard>
                              <ProfitShareSummaryLabel>
                                요금 설계 이익
                              </ProfitShareSummaryLabel>
                              <ProfitShareSummaryValue
                                $negative={sumSeasonalNum(diagnosticGap) < 0}
                              >
                                {formatWonWithUnit(
                                  sumSeasonalNum(diagnosticGap)
                                )}
                              </ProfitShareSummaryValue>
                            </ProfitShareSummaryCard>
                            <ProfitShareSummaryCard>
                              <ProfitShareSummaryLabel>
                                ESS 사업자 이익
                              </ProfitShareSummaryLabel>
                              <ProfitShareSummaryValue
                                $negative={
                                  sumSeasonalNum(diagnosticProfitShareCharge) <
                                  0
                                }
                              >
                                {formatWonWithUnit(
                                  sumSeasonalNum(diagnosticProfitShareCharge)
                                )}
                              </ProfitShareSummaryValue>
                              <ProfitShareSummarySubText>
                                판매요금 합계{' '}
                                {formatWonWithUnit(
                                  sumSeasonalNum(diagnosticDesignedEssCharge)
                                )}
                              </ProfitShareSummarySubText>
                            </ProfitShareSummaryCard>
                            <ProfitShareSummaryCard>
                              <ProfitShareSummaryLabel>
                                수요고객 요금 절감
                              </ProfitShareSummaryLabel>
                              <ProfitShareSummaryValue
                                $negative={
                                  sumSeasonalNum(
                                    diagnosticCustomerSavingsCharge
                                  ) < 0
                                }
                              >
                                {formatWonWithUnit(
                                  sumSeasonalNum(
                                    diagnosticCustomerSavingsCharge
                                  )
                                )}
                              </ProfitShareSummaryValue>
                              <ProfitShareSummarySubText>
                                계약 후 총요금{' '}
                                {formatWonWithUnit(
                                  sumSeasonalNum(diagnosticAfterCustomerCharge)
                                )}
                              </ProfitShareSummarySubText>
                            </ProfitShareSummaryCard>
                          </ProfitShareSummaryGrid>

                          <DetailWrapper $direction="column">
                            <ProfitShareRateControl>
                              <ProfitShareRateLabel htmlFor="ess-profit-rate">
                                ESS 사업자 이익 비율
                              </ProfitShareRateLabel>
                              <ProfitShareRateInputWrapper>
                                <ProfitShareRateInput
                                  id="ess-profit-rate"
                                  type="number"
                                  min={0}
                                  max={100}
                                  value={sellTOUData.essProfitRate}
                                  onChange={handleProfitShareRateChange}
                                />
                                <ProfitShareRateUnit>%</ProfitShareRateUnit>
                              </ProfitShareRateInputWrapper>
                            </ProfitShareRateControl>
                          </DetailWrapper>
                        </DetailWrapper>
                      </DetailFrame>
                    </SectionFrame>
                    <SectionFrame>
                      <SectionHeader>
                        <SectionMark />
                        <SectionTitle>부대 비용</SectionTitle>
                        <SectionDivider />
                      </SectionHeader>
                      <DetailFrame>
                        <LabelOnly label="망 이용요금" />
                        <DetailColWrapper>
                          <DetailWrapper>
                            <ColumnRadioWtihSub
                              list={[
                                {
                                  label: '고려 안함',
                                  subText: '(전력 구매 비용만 고려)',
                                },
                                {
                                  label: '내부 망 이용',
                                },
                              ]}
                              onChange={(value: string) =>
                                handleNetworkOptRadiobutton(value)
                              }
                              value={networkOptRadioValue}
                            />
                            {networkOptRadioValue === '0' ? (
                              <ChargeFrame>
                                <ChargeWrapper>-</ChargeWrapper>
                              </ChargeFrame>
                            ) : (
                              <ChargeFrame>
                                <ChargeWrapper>
                                  <InUnitContent>
                                    <InUnitItem>
                                      <InUnitLabel>
                                        내부망 단가 - 기본요금 :{' '}
                                      </InUnitLabel>
                                      <InputOnly
                                        placeholder="원/kWh"
                                        value={
                                          sellTOUData?.internalNetworkUnitBaseUnit?.toString() ||
                                          '0'
                                        }
                                        onChange={(e) =>
                                          handleDataChange(
                                            'internalNetworkUnitBaseUnit',
                                            Number(e.target.value)
                                          )
                                        }
                                        unit="원/kWh"
                                      />
                                    </InUnitItem>
                                  </InUnitContent>
                                  <InUnitContent>
                                    <InUnitItem>
                                      <InUnitLabel>
                                        내부망 단가 - 전력량요금 :{' '}
                                      </InUnitLabel>
                                      <InputOnly
                                        placeholder="원/kWh"
                                        value={
                                          sellTOUData?.internalNetworkUnitPowerUnit?.toString() ||
                                          '0'
                                        }
                                        onChange={(e) =>
                                          handleDataChange(
                                            'internalNetworkUnitPowerUnit',
                                            Number(e.target.value)
                                          )
                                        }
                                        unit="원/kWh"
                                      />
                                    </InUnitItem>
                                  </InUnitContent>
                                  <InUnitContent>
                                    <InUnitItem>
                                      <InUnitLabel>기타비용 : </InUnitLabel>
                                      <InputOnly
                                        placeholder="원/kWh"
                                        value={
                                          sellTOUData?.ectCostUnit?.toString() ||
                                          '0'
                                        }
                                        onChange={(e) =>
                                          handleDataChange(
                                            'ectCostUnit',
                                            Number(e.target.value)
                                          )
                                        }
                                        unit="원/kWh"
                                      />
                                    </InUnitItem>
                                  </InUnitContent>
                                </ChargeWrapper>
                              </ChargeFrame>
                            )}
                          </DetailWrapper>
                        </DetailColWrapper>
                      </DetailFrame>
                      {sellTOUData.networkOpt !== 'ignore' ? (
                        <DetailFrame>
                          <LabelUnit
                            label="망 이용요금 및 기타비용"
                            unit="단위: 원"
                          />
                          <DetailColWrapper>
                            <DetailWrapper>
                              <Table>
                                <TableRow>
                                  <TableCell
                                    style={{ borderTopLeftRadius: '4px' }}
                                  >
                                    봄
                                  </TableCell>
                                  <TableCell>여름</TableCell>
                                  <TableCell>가을</TableCell>
                                  <TableCell>겨울</TableCell>
                                  <TableCell
                                    style={{ borderTopRightRadius: '4px' }}
                                  >
                                    총
                                  </TableCell>
                                </TableRow>
                                <TableRow>
                                  <TableCell
                                    white
                                    style={{ borderBottomLeftRadius: '4px' }}
                                  >
                                    {Number(
                                      seasonalGridUsageCharge.spr.toFixed(0)
                                    ).toLocaleString()}
                                  </TableCell>
                                  <TableCell white>
                                    {Number(
                                      seasonalGridUsageCharge.sum.toFixed(0)
                                    ).toLocaleString()}
                                  </TableCell>
                                  <TableCell white>
                                    {Number(
                                      seasonalGridUsageCharge.fall.toFixed(0)
                                    ).toLocaleString()}
                                  </TableCell>
                                  <TableCell white>
                                    {Number(
                                      seasonalGridUsageCharge.win.toFixed(0)
                                    ).toLocaleString()}
                                  </TableCell>
                                  <TableCell
                                    white
                                    style={{ borderBottomRightRadius: '4px' }}
                                  >
                                    {Number(
                                      (
                                        seasonalGridUsageCharge.spr +
                                        seasonalGridUsageCharge.sum +
                                        seasonalGridUsageCharge.fall +
                                        seasonalGridUsageCharge.win
                                      ).toFixed(0)
                                    ).toLocaleString()}
                                  </TableCell>
                                </TableRow>
                              </Table>
                            </DetailWrapper>
                          </DetailColWrapper>
                        </DetailFrame>
                      ) : null}
                    </SectionFrame>
                  </Right>
                </Body>
              ) : (
                <AnalysisWrapper>
                  <SectionFrame>
                    <LabelOnly label="전력 구매 단가 지표" />
                    {sellPlanFeasibilitySummary}
                  </SectionFrame>

                  <AnalysisGrid>
                    <AnalysisPanel>
                      <AnalysisPanelTitle>
                        현재 설계 조건 요약
                      </AnalysisPanelTitle>
                      <AnalysisConditionGrid>
                        <AnalysisConditionItem>
                          <AnalysisConditionLabel>
                            수용가
                          </AnalysisConditionLabel>
                          <AnalysisConditionValue>
                            {sellTOUData.cust?.name || '-'}
                          </AnalysisConditionValue>
                        </AnalysisConditionItem>
                        <AnalysisConditionItem>
                          <AnalysisConditionLabel>
                            선택 구매요금제
                          </AnalysisConditionLabel>
                          <AnalysisConditionValue>
                            {selectedPurchasePlanText}
                          </AnalysisConditionValue>
                        </AnalysisConditionItem>
                        <AnalysisConditionItem>
                          <AnalysisConditionLabel>
                            판매요금제 유형
                          </AnalysisConditionLabel>
                          <AnalysisConditionValue>
                            {getPlanTypeLabel(sellTOUData.planType)}
                          </AnalysisConditionValue>
                        </AnalysisConditionItem>
                        <AnalysisConditionItem>
                          <AnalysisConditionLabel>
                            ESS-한전 전력 분담
                          </AnalysisConditionLabel>
                          <AnalysisConditionValue>
                            {powerShareText}
                          </AnalysisConditionValue>
                        </AnalysisConditionItem>
                        <AnalysisConditionItem>
                          <AnalysisConditionLabel>
                            변경될 한전 계약전력
                          </AnalysisConditionLabel>
                          <AnalysisConditionValue>
                            {afterKepcoContractedPowerText}
                          </AnalysisConditionValue>
                        </AnalysisConditionItem>
                        <AnalysisConditionItem>
                          <AnalysisConditionLabel>
                            ESS 사업자 이익 비율
                          </AnalysisConditionLabel>
                          <AnalysisConditionValue>
                            {profitShareText}
                          </AnalysisConditionValue>
                        </AnalysisConditionItem>
                        <AnalysisConditionItem>
                          <AnalysisConditionLabel>
                            망비용 조건
                          </AnalysisConditionLabel>
                          <AnalysisConditionValue>
                            {networkConditionText}
                          </AnalysisConditionValue>
                        </AnalysisConditionItem>
                        <AnalysisConditionItem>
                          <AnalysisConditionLabel>
                            RE100 조건
                          </AnalysisConditionLabel>
                          <AnalysisConditionValue>
                            {re100ConditionText}
                          </AnalysisConditionValue>
                        </AnalysisConditionItem>
                      </AnalysisConditionGrid>
                    </AnalysisPanel>

                    <SellPlanFeasibilityChart
                      data={sellPlanFeasibilityCurve}
                      primaryLabel={chartPrimaryFeasibilityLabel}
                      comparisonData={comparisonSellPlanFeasibilityCurve}
                      comparisonLabel={chartComparisonFeasibilityLabel}
                      canAnalyze={canAnalyzeSellPlanFeasibility}
                      isLoading={isSellPlanFeasibilityLoading}
                      isStale={false}
                      onAnalyze={() => undefined}
                      height="360px"
                      showSummary={false}
                      showAnalyzeButton={false}
                    />
                  </AnalysisGrid>

                  <SectionFrame>
                    <LabelOnly label="ESS 사업자 이익 비율 분석" />
                    <SellPlanProfitShareSensitivityChart
                      data={profitShareSensitivityData}
                      currentEssProfitRate={sellTOUData.essProfitRate}
                    />
                  </SectionFrame>
                </AnalysisWrapper>
              )}
            </BodyWrapper>
          </ContentWrapper>
        )}
      </PageWrapper>
    </>
  )
}
